import { jsxs as F, jsx as N, Fragment as Ge } from "react/jsx-runtime";
import { UndoRedo as fr, Gapcursor as pr, Focus as mr } from "@tiptap/extensions";
import Mt, { useRef as K, useState as we, useEffect as j, useLayoutEffect as gr } from "react";
import { NodeViewWrapper as Ze, NodeViewContent as Qe, ReactNodeViewRenderer as pt, useCurrentEditor as tn, useEditorState as yr, useEditor as wr, EditorContent as br } from "@tiptap/react";
import { Node as A, mergeAttributes as L, wrappingInputRule as st, Extension as G, Mark as At, markPasteRule as jt, markInputRule as mt, textblockTypeInputRule as vr, isTextSelection as xr, posToDOMRect as en, getText as Er, getTextSerializersFromSchema as Tr } from "@tiptap/core";
import { BulletList as Sr, OrderedList as kr, ListItem as Cr } from "@tiptap/extension-list";
import bt from "katex";
import Nr from "@tiptap/extension-code-block";
import { flip as nn, shift as rn, offset as sn, arrow as on, size as ln, autoPlacement as an, hide as cn, inline as un, computePosition as hn } from "@floating-ui/dom";
import { createPortal as dn } from "react-dom";
const Or = A.create({
  name: "m",
  content: "text*",
  group: "inline math",
  inline: !0,
  parseHTML() {
    return [{ tag: "m" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "inlineMath" }, e)];
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: t }) => {
      const n = document.createElement("span");
      n.classList.add("node-view", "math"), Object.entries(t).forEach(([c, u]) => {
        n.setAttribute(c, u);
      });
      const i = document.createElement("span"), r = document.createElement("span"), s = e.textContent.trim();
      return i.classList.add("katex-rendered"), i.innerHTML = bt.renderToString(s, { throwOnError: !1 }), i.contentEditable = "false", i.style.pointerEvents = "none", r.classList.add("edit-math"), r.classList.add("is-editable"), r.innerHTML = "<m>" + e.textContent + "</m>", r.contentEditable = "true", r.draggable = !1, new MutationObserver(() => {
        const c = r.textContent || "";
        i.innerHTML = bt.renderToString(c, {
          throwOnError: !1
        });
      }).observe(r, { characterData: !0, subtree: !0 }), r.addEventListener("focus", () => {
        n.classList.add("has-focus");
      }), r.addEventListener("blur", () => {
        n.classList.remove("has-focus");
      }), n.appendChild(r), n.appendChild(i), {
        dom: n,
        contentDOM: r
      };
    };
  }
}), Ir = A.create({
  name: "me",
  content: "text*",
  group: "inline math",
  inline: !0,
  parseHTML() {
    return [{ tag: "me" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["div", L({ class: "displayMath" }, e)];
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: t }) => {
      const n = document.createElement("div");
      n.classList.add("node-view", "math"), n.classList.add("display"), Object.entries(t).forEach(([c, u]) => {
        n.setAttribute(c, u);
      });
      const i = document.createElement("span"), r = document.createElement("span"), s = e.textContent.trim();
      return i.classList.add("katex-rendered"), i.innerHTML = bt.renderToString(s, { throwOnError: !1 }), i.contentEditable = "false", i.style.pointerEvents = "none", r.classList.add("edit-math"), r.classList.add("is-editable"), r.contentEditable = "true", r.innerHTML = "<md>" + e.textContent + "</md>", r.draggable = !1, new MutationObserver(() => {
        const c = r.textContent || "";
        i.innerHTML = bt.renderToString(c, {
          throwOnError: !1
        });
      }).observe(r, { characterData: !0, subtree: !0 }), r.addEventListener("focus", () => {
        n.classList.add("has-focus");
      }), r.addEventListener("blur", () => {
        n.classList.remove("has-focus");
      }), n.appendChild(r), n.appendChild(i), {
        dom: n,
        contentDOM: r
      };
    };
  }
}), Mr = A.create({
  name: "md",
  content: "text*",
  group: "inline math",
  inline: !0,
  parseHTML() {
    return [{ tag: "md" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["div", L({ class: "displayMath" }, e)];
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: t }) => {
      const n = document.createElement("div");
      n.classList.add("node-view", "math"), n.classList.add("display"), Object.entries(t).forEach(([c, u]) => {
        n.setAttribute(c, u);
      });
      const i = document.createElement("span"), r = document.createElement("span"), s = e.textContent.trim();
      return i.classList.add("katex-rendered"), i.innerHTML = bt.renderToString(s, { throwOnError: !1 }), i.contentEditable = "false", i.style.pointerEvents = "none", r.classList.add("edit-math"), r.classList.add("is-editable"), r.innerHTML = "<md>" + e.textContent + "</md>", r.contentEditable = "true", r.draggable = !1, new MutationObserver(() => {
        const c = r.textContent || "";
        i.innerHTML = bt.renderToString(c, {
          throwOnError: !1
        });
      }).observe(r, { characterData: !0, subtree: !0 }), r.addEventListener("focus", () => {
        n.classList.add("has-focus");
      }), r.addEventListener("blur", () => {
        n.classList.remove("has-focus");
      }), n.appendChild(r), n.appendChild(i), {
        dom: n,
        contentDOM: r
      };
    };
  }
}), Lr = A.create({
  name: "ptxdoc",
  content: "title? (BasicBlock|block|rawptx|division)*",
  group: "root",
  selectable: !1,
  draggable: !1,
  defining: !1,
  parseHTML() {
    return [
      {
        tag: "ptxdoc"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "div",
      L({ class: "ptxdoc", ptxtag: "ptxdoc" }, e),
      0
    ];
  }
}), $r = A.create({
  name: "introduction",
  content: "(BasicBlock|block|rawptx)*",
  group: "division introduction",
  selectable: !0,
  draggable: !0,
  defining: !1,
  parseHTML() {
    return [
      {
        tag: "introduction"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "article",
      L(
        { class: "introduction", label: "introduction" },
        e
      ),
      0
    ];
  },
  addInputRules() {
    return [
      st({
        find: new RegExp("^#intro\\s$"),
        type: this.type
      })
    ];
  }
}), Ar = A.create({
  name: "chapter",
  content: "title ((introduction?|section+)|(BasicBlock|block|rawptx)+)",
  group: "division",
  selectable: !0,
  draggable: !0,
  defining: !1,
  parseHTML() {
    return [
      {
        tag: "chapter"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "section",
      L({ class: "chapter", ptxtag: "chapter" }, e),
      0
    ];
  },
  addInputRules() {
    return [
      st({
        find: new RegExp("^#ch\\s$"),
        type: this.type
      })
    ];
  }
}), Rr = A.create({
  name: "section",
  content: "title ((introduction?|subsection+)|(BasicBlock|block|rawptx)+)",
  group: "division",
  selectable: !0,
  draggable: !0,
  defining: !1,
  parseHTML() {
    return [
      {
        tag: "section"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "section",
      L({ class: "section", ptxtag: "section" }, e),
      0
    ];
  },
  addInputRules() {
    return [
      st({
        find: new RegExp("^#sec\\s$"),
        type: this.type
      })
    ];
  }
}), Dr = A.create({
  name: "subsection",
  content: "title (BasicBlock|block|rawptx)+",
  group: "division",
  selectable: !1,
  draggable: !0,
  defining: !1,
  parseHTML() {
    return [
      {
        tag: "subsection"
      }
    ];
  },
  addAttributes() {
    return {
      label: {
        default: null,
        parseHTML: (e) => e.getAttribute("label")
      },
      "xml:id": {
        parseHTML: (e) => e.getAttribute("xml:id")
      }
    };
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "section",
      L(
        { class: "subsection", ptxtag: "subsection" },
        e
      ),
      0
    ];
  },
  addInputRules() {
    return [
      st({
        find: new RegExp("^#subsec\\s$"),
        type: this.type
      })
    ];
  }
}), zr = G.create({
  name: "divisions",
  addExtensions() {
    return [Lr, $r, Ar, Rr, Dr];
  }
});
var Pr = A.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), Hr = A.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", L(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: i }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: r, storedMarks: s } = n;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: c } = i.extensionManager, u = s || r.$to.parentOffset && r.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: d, dispatch: p }) => {
            if (p && u && a) {
              const m = u.filter((w) => c.includes(w.type.name));
              d.ensureMarks(m);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
});
const Ur = Pr.extend({}), Br = Hr.extend({}), _r = At.create({
  name: "term",
  group: "inline",
  parseHTML() {
    return [{ tag: "term" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "term" }, e), 0];
  },
  addInputRules() {
    return [
      mt({
        find: /(?:^|\s)(<term>(.*?)<\/term>)$/,
        type: this.type
      }),
      mt({
        find: /(?:^|\s)(_(.*?)_)$/,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      jt({
        find: /(?:^|\s)(<term>(.*?)<\/term>)/g,
        type: this.type
      })
    ];
  }
}), Jr = At.create({
  name: "em",
  group: "inline",
  parseHTML() {
    return [{ tag: "em" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "em" }, e), 0];
  },
  addInputRules() {
    return [
      mt({
        find: /(?:^|\s)(<em>(.*?)<\/em>)$/,
        type: this.type
      }),
      mt({
        find: /(?:^|\s)(\*(.*?)\*)$/,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      jt({
        find: /(?:^|\s)(<em>(.*?)<\/em>)/g,
        type: this.type
      })
    ];
  }
}), Fr = At.create({
  name: "alert",
  group: "inline",
  parseHTML() {
    return [{ tag: "alert" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "alert" }, e), 0];
  },
  addInputRules() {
    return [
      mt({
        find: /(?:^|\s)(<alert>(.*?)<\/alert>)$/,
        type: this.type
      }),
      mt({
        find: /(?:^|\s)(\*\*(.*?)\*\*)$/,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      jt({
        find: /(?:^|\s)(<alert>(.*?)<\/alert>)/g,
        type: this.type
      })
    ];
  }
}), Xr = At.create({
  name: "c",
  group: "inline",
  parseHTML() {
    return [{ tag: "c" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "c" }, e), 0];
  },
  addInputRules() {
    return [
      mt({
        find: /(?:^|\s)(<c>(.*?)<\/c>)$/,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      jt({
        find: /(?:^|\s)(<c>(.*?)<\/c>)/g,
        type: this.type
      })
    ];
  }
}), Kr = G.create({
  name: "myinline",
  addExtensions() {
    return [Ur, Br, _r, Jr, Fr, Xr];
  }
}), Rt = (e) => {
  const t = e.node.type.name.charAt(0).toUpperCase() + e.node.type.name.slice(1);
  return /* @__PURE__ */ F(
    Ze,
    {
      className: "block-component",
      ptxtag: e.node.type.name,
      children: [
        /* @__PURE__ */ F("div", { className: "block-title", children: [
          t,
          "."
        ] }),
        /* @__PURE__ */ N(Qe, { className: "thm-component-content" })
      ]
    }
  );
}, fn = () => /* @__PURE__ */ F(Ze, { className: "proof", ptxtag: "proof", children: [
  /* @__PURE__ */ N("div", { className: "block-title", children: "Proof." }),
  /* @__PURE__ */ N(Qe, { className: "thm-component-content" })
] });
var Zt, Ce;
function jr() {
  if (Ce) return Zt;
  Ce = 1;
  var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, i = Object.prototype.hasOwnProperty, r = (l, o) => {
    for (var h in o)
      e(l, h, { get: o[h], enumerable: !0 });
  }, s = (l, o, h, f) => {
    if (o && typeof o == "object" || typeof o == "function")
      for (let g of n(o))
        !i.call(l, g) && g !== h && e(l, g, { get: () => o[g], enumerable: !(f = t(o, g)) || f.enumerable });
    return l;
  }, a = (l) => s(e({}, "__esModule", { value: !0 }), l), c = {};
  r(c, {
    XmlCdata: () => Z,
    XmlComment: () => Et,
    XmlDeclaration: () => Tt,
    XmlDocument: () => St,
    XmlDocumentType: () => kt,
    XmlElement: () => at,
    XmlError: () => Ct,
    XmlNode: () => x,
    XmlProcessingInstruction: () => ct,
    XmlText: () => J,
    parseXml: () => Gt
  }), Zt = a(c);
  var u = "", d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, p = class {
    constructor(l) {
      if (this.k = this.u(l, !0), this.d = 0, this.length = l.length, this.l = this.k !== this.length, this.h = l, this.l) {
        let o = [];
        for (let h = 0, f = 0; f < this.k; ++f)
          o[f] = h, h += l.codePointAt(h) > 65535 ? 2 : 1;
        this.A = o;
      }
    }
    /**
     * Whether the current character index is at the end of the input string.
     */
    get B() {
      return this.d >= this.k;
    }
    // -- Protected Methods ------------------------------------------------------
    /**
     * Returns the number of characters in the given string, which may differ from
     * the byte length if the string contains multibyte characters.
     */
    u(l, o = this.l) {
      return o ? l.replace(d, "_").length : l.length;
    }
    // -- Public Methods ---------------------------------------------------------
    /**
     * Advances the scanner by the given number of characters, stopping if the end
     * of the string is reached.
     */
    p(l = 1) {
      this.d = Math.min(this.k, this.d + l);
    }
    /**
     * Returns the byte index of the given character index in the string. The two
     * may differ in strings that contain multibyte characters.
     */
    f(l = this.d) {
      var o;
      return this.l ? (o = this.A[l]) != null ? o : 1 / 0 : l;
    }
    /**
     * Consumes and returns the given number of characters if possible, advancing
     * the scanner and stopping if the end of the string is reached.
     *
     * If no characters could be consumed, an empty string will be returned.
     */
    G(l = 1) {
      let o = this.m(l);
      return this.p(l), o;
    }
    /**
     * Consumes and returns the given number of bytes if possible, advancing the
     * scanner and stopping if the end of the string is reached.
     *
     * It's up to the caller to ensure that the given byte count doesn't split a
     * multibyte character.
     *
     * If no bytes could be consumed, an empty string will be returned.
     */
    v(l) {
      let o = this.f(), h = this.h.slice(o, o + l);
      return this.p(this.u(h)), h;
    }
    /**
     * Consumes and returns all characters for which the given function returns
     * `true`, stopping when `false` is returned or the end of the input is
     * reached.
     */
    w(l) {
      let { length: o, l: h, h: f } = this, g = this.f(), v = g;
      if (h)
        for (; v < o; ) {
          let O = f[v], $ = O >= "\uD800" && O <= "\uDBFF";
          if ($ && (O += f[v + 1]), !l(O))
            break;
          v += $ ? 2 : 1;
        }
      else
        for (; v < o && l(f[v]); )
          ++v;
      return this.v(v - g);
    }
    /**
     * Consumes the given string if it exists at the current character index, and
     * advances the scanner.
     *
     * If the given string doesn't exist at the current character index, an empty
     * string will be returned and the scanner will not be advanced.
     */
    b(l) {
      let { length: o } = l, h = this.f();
      return l === this.h.slice(h, h + o) ? (this.p(o === 1 ? 1 : this.u(l)), l) : u;
    }
    /**
     * Consumes characters until the given global regex is matched, advancing the
     * scanner up to (but not beyond) the beginning of the match. If the regex
     * doesn't match, nothing will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    x(l) {
      let o = this.h.slice(this.f()).search(l);
      return o > 0 ? this.v(o) : u;
    }
    /**
     * Consumes characters until the given string is found, advancing the scanner
     * up to (but not beyond) that point. If the string is never found, nothing
     * will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    s(l) {
      let o = this.f(), h = this.h.indexOf(l, o);
      return h > 0 ? this.v(h - o) : u;
    }
    /**
     * Returns the given number of characters starting at the current character
     * index, without advancing the scanner and without exceeding the end of the
     * input string.
     */
    m(l = 1) {
      let { d: o, h } = this;
      return this.l ? h.slice(this.f(o), this.f(o + l)) : h.slice(o, o + l);
    }
    /**
     * Resets the scanner position to the given character _index_, or to the start
     * of the input string if no index is given.
     *
     * If _index_ is negative, the scanner position will be moved backward by that
     * many characters, stopping if the beginning of the string is reached.
     */
    n(l = 0) {
      this.d = l >= 0 ? Math.min(this.k, l) : Math.max(0, this.d + l);
    }
  }, m = /["&<]/, w = /['&<]/, y = /\r\n|[\n\r\t]/g, b = /<|&|]]>/, E = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }));
  function S(l) {
    let o = l.codePointAt(0);
    return o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 48 && o <= 57 || o === 45 || o === 46 || o === 183 || o >= 768 && o <= 879 || o === 8255 || o === 8256 || T(l, o);
  }
  function T(l, o = l.codePointAt(0)) {
    return o >= 97 && o <= 122 || o >= 65 && o <= 90 || o === 58 || o === 95 || o >= 192 && o <= 214 || o >= 216 && o <= 246 || o >= 248 && o <= 767 || o >= 880 && o <= 893 || o >= 895 && o <= 8191 || o === 8204 || o === 8205 || o >= 8304 && o <= 8591 || o >= 11264 && o <= 12271 || o >= 12289 && o <= 55295 || o >= 63744 && o <= 64975 || o >= 65008 && o <= 65533 || o >= 65536 && o <= 983039;
  }
  function P(l) {
    return l === "#" || S(l);
  }
  function R(l) {
    let o = l.codePointAt(0);
    return o === 32 || o === 9 || o === 10 || o === 13;
  }
  function z(l) {
    return l >= 32 && l <= 55295 || l === 10 || l === 9 || l === 13 || l >= 57344 && l <= 65533 || l >= 65536 && l <= 1114111;
  }
  var k = class pn {
    constructor() {
      this.parent = null, this.start = -1, this.end = -1;
    }
    /**
     * Document that contains this node, or `null` if this node is not associated
     * with a document.
     */
    get document() {
      var o, h;
      return (h = (o = this.parent) == null ? void 0 : o.document) != null ? h : null;
    }
    /**
     * Whether this node is the root node of the document (also known as the
     * document element).
     */
    get isRootNode() {
      return this.parent !== null && this.parent === this.document && this.type === pn.TYPE_ELEMENT;
    }
    /**
     * Whether whitespace should be preserved in the content of this element and
     * its children.
     *
     * This is influenced by the value of the special `xml:space` attribute, and
     * will be `true` for any node whose `xml:space` attribute is set to
     * "preserve". If a node has no such attribute, it will inherit the value of
     * the nearest ancestor that does (if any).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-white-space
     */
    get preserveWhitespace() {
      var o;
      return !!((o = this.parent) != null && o.preserveWhitespace);
    }
    /**
     * Type of this node.
     *
     * The value of this property is a string that matches one of the static
     * `TYPE_*` properties on the `XmlNode` class (e.g. `TYPE_ELEMENT`,
     * `TYPE_TEXT`, etc.).
     *
     * The `XmlNode` class itself is a base class and doesn't have its own type
     * name.
     */
    get type() {
      return "";
    }
    /**
     * Returns a JSON-serializable object representing this node, minus properties
     * that could result in circular references.
     */
    toJSON() {
      let o = {
        type: this.type
      };
      return this.isRootNode && (o.isRootNode = !0), this.preserveWhitespace && (o.preserveWhitespace = !0), this.start !== -1 && (o.start = this.start, o.end = this.end), o;
    }
  };
  k.TYPE_CDATA = "cdata", k.TYPE_COMMENT = "comment", k.TYPE_DOCUMENT = "document", k.TYPE_DOCUMENT_TYPE = "doctype", k.TYPE_ELEMENT = "element", k.TYPE_PROCESSING_INSTRUCTION = "pi", k.TYPE_TEXT = "text", k.TYPE_XML_DECLARATION = "xmldecl";
  var x = k, J = class extends x {
    constructor(l = "") {
      super(), this.text = l;
    }
    get type() {
      return x.TYPE_TEXT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        text: this.text
      });
    }
  }, Z = class extends J {
    get type() {
      return x.TYPE_CDATA;
    }
  }, Et = class extends x {
    constructor(l = "") {
      super(), this.content = l;
    }
    get type() {
      return x.TYPE_COMMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        content: this.content
      });
    }
  }, Tt = class extends x {
    constructor(l, o, h) {
      super(), this.version = l, this.encoding = o ?? null, this.standalone = h ?? null;
    }
    get type() {
      return x.TYPE_XML_DECLARATION;
    }
    toJSON() {
      let l = x.prototype.toJSON.call(this);
      l.version = this.version;
      for (let o of ["encoding", "standalone"])
        this[o] !== null && (l[o] = this[o]);
      return l;
    }
  }, at = class mn extends x {
    constructor(o, h = /* @__PURE__ */ Object.create(null), f = []) {
      super(), this.name = o, this.attributes = h, this.children = f;
    }
    /**
     * Whether this element is empty (meaning it has no children).
     */
    get isEmpty() {
      return this.children.length === 0;
    }
    get preserveWhitespace() {
      let o = this;
      for (; o instanceof mn; ) {
        if ("xml:space" in o.attributes)
          return o.attributes["xml:space"] === "preserve";
        o = o.parent;
      }
      return !1;
    }
    /**
     * Text content of this element and all its descendants.
     */
    get text() {
      return this.children.map((o) => "text" in o ? o.text : "").join("");
    }
    get type() {
      return x.TYPE_ELEMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        name: this.name,
        attributes: this.attributes,
        children: this.children.map((o) => o.toJSON())
      });
    }
  }, St = class extends x {
    constructor(l = []) {
      super(), this.children = l;
    }
    get document() {
      return this;
    }
    /**
     * Root element of this document, or `null` if this document is empty.
     */
    get root() {
      for (let l of this.children)
        if (l instanceof at)
          return l;
      return null;
    }
    /**
     * Text content of this document and all its descendants.
     */
    get text() {
      return this.children.map((l) => "text" in l ? l.text : "").join("");
    }
    get type() {
      return x.TYPE_DOCUMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        children: this.children.map((l) => l.toJSON())
      });
    }
  }, kt = class extends x {
    constructor(l, o, h, f) {
      super(), this.name = l, this.publicId = o ?? null, this.systemId = h ?? null, this.internalSubset = f ?? null;
    }
    get type() {
      return x.TYPE_DOCUMENT_TYPE;
    }
    toJSON() {
      let l = x.prototype.toJSON.call(this);
      l.name = this.name;
      for (let o of ["publicId", "systemId", "internalSubset"])
        this[o] !== null && (l[o] = this[o]);
      return l;
    }
  }, Ct = class extends Error {
    constructor(l, o, h) {
      let f = 1, g = "", v = 1;
      for (let ut = 0; ut < o; ++ut) {
        let Ot = h[ut];
        Ot === `
` ? (f = 1, g = "", v += 1) : (f += 1, g += Ot);
      }
      let O = h.indexOf(`
`, o);
      g += O === -1 ? h.slice(o) : h.slice(o, O);
      let $ = 0;
      g.length > 50 && (f < 40 ? g = g.slice(0, 50) : ($ = f - 20, g = g.slice($, f + 30))), super(
        `${l} (line ${v}, column ${f})
  ${g}
` + " ".repeat(f - $ + 1) + `^
`
      ), this.column = f, this.excerpt = g, this.line = v, this.name = "XmlError", this.pos = o;
    }
  }, ct = class extends x {
    constructor(l, o = "") {
      super(), this.name = l, this.content = o;
    }
    get type() {
      return x.TYPE_PROCESSING_INSTRUCTION;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        name: this.name,
        content: this.content
      });
    }
  }, Nt = "", Yt = class {
    /**
     * @param xml XML string to parse.
     * @param options Parser options.
     */
    constructor(l, o = {}) {
      let h = this.document = new St();
      this.j = h, this.g = o, this.c = new p(l), this.g.includeOffsets && (h.start = 0, h.end = l.length), this.parse();
    }
    /**
     * Adds the given `XmlNode` as a child of `this.currentNode`.
     */
    i(l, o) {
      return l.parent = this.j, this.g.includeOffsets && (l.start = this.c.f(o), l.end = this.c.f()), this.j.children.push(l), !0;
    }
    /**
     * Adds the given _text_ to the document, either by appending it to a
     * preceding `XmlText` node (if possible) or by creating a new `XmlText` node.
     */
    y(l, o) {
      let { children: h } = this.j, { length: f } = h;
      if (l = Q(l), f > 0) {
        let g = h[f - 1];
        if (g?.type === x.TYPE_TEXT) {
          let v = g;
          return v.text += l, this.g.includeOffsets && (v.end = this.c.f()), !0;
        }
      }
      return this.i(new J(l), o);
    }
    /**
     * Consumes element attributes.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-starttags
     */
    H() {
      let l = /* @__PURE__ */ Object.create(null);
      for (; this.e(); ) {
        let o = this.q();
        if (!o)
          break;
        let h = this.t() && this.I();
        if (h === !1)
          throw this.a("Attribute value expected");
        if (o in l)
          throw this.a(`Duplicate attribute: ${o}`);
        if (o === "xml:space" && h !== "default" && h !== "preserve")
          throw this.a('Value of the `xml:space` attribute must be "default" or "preserve"');
        l[o] = h;
      }
      if (this.g.sortAttributes) {
        let o = Object.keys(l).sort(), h = /* @__PURE__ */ Object.create(null);
        for (let f = 0; f < o.length; ++f) {
          let g = o[f];
          h[g] = l[g];
        }
        l = h;
      }
      return l;
    }
    /**
     * Consumes an `AttValue` (attribute value) if possible.
     *
     * @returns
     *   Contents of the `AttValue` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that an `AttValue` was consumed but
     *   was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-AttValue
     */
    I() {
      let { c: l } = this, o = l.m();
      if (o !== '"' && o !== "'")
        return !1;
      l.p();
      let h, f = !1, g = Nt, v = o === '"' ? m : w;
      t: for (; !l.B; )
        switch (h = l.x(v), h && (this.o(h), g += h.replace(y, " ")), l.m()) {
          case o:
            f = !0;
            break t;
          case "&":
            g += this.C();
            continue;
          case "<":
            throw this.a("Unescaped `<` is not allowed in an attribute value");
          default:
            break t;
        }
      if (!f)
        throw this.a("Unclosed attribute");
      return l.p(), g;
    }
    /**
     * Consumes a CDATA section if possible.
     *
     * @returns Whether a CDATA section was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-cdata-sect
     */
    J() {
      let { c: l } = this, o = l.d;
      if (!l.b("<![CDATA["))
        return !1;
      let h = l.s("]]>");
      if (this.o(h), !l.b("]]>"))
        throw this.a("Unclosed CDATA section");
      return this.g.preserveCdata ? this.i(new Z(Q(h)), o) : this.y(h, o);
    }
    /**
     * Consumes character data if possible.
     *
     * @returns Whether character data was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dt-chardata
     */
    K() {
      let { c: l } = this, o = l.d, h = l.x(b);
      if (!h)
        return !1;
      if (this.o(h), l.m(3) === "]]>")
        throw this.a("Element content may not contain the CDATA section close delimiter `]]>`");
      return this.y(h, o);
    }
    /**
     * Consumes a comment if possible.
     *
     * @returns Whether a comment was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Comment
     */
    D() {
      let { c: l } = this, o = l.d;
      if (!l.b("<!--"))
        return !1;
      let h = l.s("--");
      if (this.o(h), !l.b("-->"))
        throw l.m(2) === "--" ? this.a("The string `--` isn't allowed inside a comment") : this.a("Unclosed comment");
      return this.g.preserveComments ? this.i(new Et(Q(h)), o) : !0;
    }
    /**
     * Consumes a reference in a content context if possible.
     *
     * This differs from `consumeReference()` in that a consumed reference will be
     * added to the document as a text node instead of returned.
     *
     * @returns Whether a reference was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#entproc
     */
    L() {
      let l = this.c.d, o = this.C();
      return o ? this.y(o, l) : !1;
    }
    /**
     * Consumes a doctype declaration if possible.
     *
     * This is a loose implementation since doctype declarations are currently
     * discarded without further parsing.
     *
     * @returns Whether a doctype declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dtd
     */
    M() {
      let { c: l } = this, o = l.d;
      if (!l.b("<!DOCTYPE"))
        return !1;
      let h = this.e() && this.q();
      if (!h)
        throw this.a("Expected a name");
      let f, g;
      if (this.e()) {
        if (l.b("PUBLIC")) {
          if (f = this.e() && this.N(), f === !1)
            throw this.a("Expected a public identifier");
          this.e();
        }
        if (f !== void 0 || l.b("SYSTEM")) {
          if (this.e(), g = this.r(), g === !1)
            throw this.a("Expected a system identifier");
          this.e();
        }
      }
      let v;
      if (l.b("[")) {
        if (v = l.x(/\][\x20\t\r\n]*>/), !l.b("]"))
          throw this.a("Unclosed internal subset");
        this.e();
      }
      if (!l.b(">"))
        throw this.a("Unclosed doctype declaration");
      return this.g.preserveDocumentType ? this.i(new kt(h, f, g, v), o) : !0;
    }
    /**
     * Consumes an element if possible.
     *
     * @returns Whether an element was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-element
     */
    E() {
      let { c: l } = this, o = l.d;
      if (!l.b("<"))
        return !1;
      let h = this.q();
      if (!h)
        return l.n(o), !1;
      let f = this.H(), g = !!l.b("/>"), v = new at(h, f);
      if (v.parent = this.j, !g) {
        if (!l.b(">"))
          throw this.a(`Unclosed start tag for element \`${h}\``);
        this.j = v;
        do
          this.K();
        while (this.E() || this.L() || this.J() || this.F() || this.D());
        let O = l.d, $;
        if (!l.b("</") || !($ = this.q()) || $ !== h)
          throw l.n(O), this.a(`Missing end tag for element ${h}`);
        if (this.e(), !l.b(">"))
          throw this.a(`Unclosed end tag for element ${h}`);
        this.j = v.parent;
      }
      return this.i(v, o);
    }
    /**
     * Consumes an `Eq` production if possible.
     *
     * @returns Whether an `Eq` production was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Eq
     */
    t() {
      return this.e(), this.c.b("=") ? (this.e(), !0) : !1;
    }
    /**
     * Consumes `Misc` content if possible.
     *
     * @returns Whether anything was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Misc
     */
    z() {
      return this.D() || this.F() || this.e();
    }
    /**
     * Consumes one or more `Name` characters if possible.
     *
     * @returns `Name` characters, or an empty string if none were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Name
     */
    q() {
      return T(this.c.m()) ? this.c.w(S) : Nt;
    }
    /**
     * Consumes a processing instruction if possible.
     *
     * @returns Whether a processing instruction was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-pi
     */
    F() {
      let { c: l } = this, o = l.d;
      if (!l.b("<?"))
        return !1;
      let h = this.q();
      if (h) {
        if (h.toLowerCase() === "xml")
          throw l.n(o), this.a("XML declaration isn't allowed here");
      } else
        throw this.a("Invalid processing instruction");
      if (!this.e()) {
        if (l.b("?>"))
          return this.i(new ct(h), o);
        throw this.a("Whitespace is required after a processing instruction name");
      }
      let f = l.s("?>");
      if (this.o(f), !l.b("?>"))
        throw this.a("Unterminated processing instruction");
      return this.i(new ct(h, Q(f)), o);
    }
    /**
     * Consumes a prolog if possible.
     *
     * @returns Whether a prolog was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-prolog-dtd
     */
    O() {
      let { c: l } = this, o = l.d;
      for (this.P(); this.z(); )
        ;
      if (this.M())
        for (; this.z(); )
          ;
      return o < l.d;
    }
    /**
     * Consumes a public identifier literal if possible.
     *
     * @returns
     *   Value of the public identifier literal minus quotes, or `false` if
     *   nothing was consumed. An empty string indicates that a public id literal
     *   was consumed but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-PubidLiteral
     */
    N() {
      let l = this.c.d, o = this.r();
      if (o !== !1 && !/^[-\x20\r\na-zA-Z0-9'()+,./:=?;!*#@$_%]*$/.test(o))
        throw this.c.n(l), this.a("Invalid character in public identifier");
      return o;
    }
    /**
     * Consumes a reference if possible.
     *
     * This differs from `consumeContentReference()` in that a consumed reference
     * will be returned rather than added to the document.
     *
     * @returns
     *   Parsed reference value, or `false` if nothing was consumed (to
     *   distinguish from a reference that resolves to an empty string).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Reference
     */
    C() {
      let { c: l } = this;
      if (!l.b("&"))
        return !1;
      let o = l.w(P);
      if (l.G() !== ";")
        throw this.a("Unterminated reference (a reference must end with `;`)");
      let h;
      if (o[0] === "#") {
        let f = o[1] === "x" ? parseInt(o.slice(2), 16) : parseInt(o.slice(1), 10);
        if (isNaN(f))
          throw this.a("Invalid character reference");
        if (!z(f))
          throw this.a("Character reference resolves to an invalid character");
        h = String.fromCodePoint(f);
      } else if (h = E[o], h === void 0) {
        let {
          ignoreUndefinedEntities: f,
          resolveUndefinedEntity: g
        } = this.g, v = `&${o};`;
        if (g) {
          let O = g(v);
          if (O != null) {
            let $ = typeof O;
            if ($ !== "string")
              throw new TypeError(`\`resolveUndefinedEntity()\` must return a string, \`null\`, or \`undefined\`, but returned a value of type ${$}`);
            return O;
          }
        }
        if (f)
          return v;
        throw l.n(-v.length), this.a(`Named entity isn't defined: ${v}`);
      }
      return h;
    }
    /**
     * Consumes a `SystemLiteral` if possible.
     *
     * A `SystemLiteral` is similar to an attribute value, but allows the
     * characters `<` and `&` and doesn't replace references.
     *
     * @returns
     *   Value of the `SystemLiteral` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that a `SystemLiteral` was consumed
     *   but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-SystemLiteral
     */
    r() {
      let { c: l } = this, o = l.b('"') || l.b("'");
      if (!o)
        return !1;
      let h = l.s(o);
      if (this.o(h), !l.b(o))
        throw this.a("Missing end quote");
      return h;
    }
    /**
     * Consumes one or more whitespace characters if possible.
     *
     * @returns Whether any whitespace characters were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#white
     */
    e() {
      return !!this.c.w(R);
    }
    /**
     * Consumes an XML declaration if possible.
     *
     * @returns Whether an XML declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-XMLDecl
     */
    P() {
      let { c: l } = this, o = l.d;
      if (!l.b("<?xml"))
        return !1;
      if (!this.e())
        throw this.a("Invalid XML declaration");
      let h = !!l.b("version") && this.t() && this.r();
      if (h === !1)
        throw this.a("XML version is missing or invalid");
      if (!/^1\.[0-9]+$/.test(h))
        throw this.a("Invalid character in version number");
      let f, g;
      if (this.e()) {
        if (f = !!l.b("encoding") && this.t() && this.r(), f) {
          if (!/^[A-Za-z][\w.-]*$/.test(f))
            throw this.a("Invalid character in encoding name");
          this.e();
        }
        if (g = !!l.b("standalone") && this.t() && this.r(), g) {
          if (g !== "yes" && g !== "no")
            throw this.a('Only "yes" and "no" are permitted as values of `standalone`');
          this.e();
        }
      }
      if (!l.b("?>"))
        throw this.a("Invalid or unclosed XML declaration");
      return this.g.preserveXmlDeclaration ? this.i(new Tt(
        h,
        f || void 0,
        g || void 0
      ), o) : !0;
    }
    /**
     * Returns an `XmlError` for the current scanner position.
     */
    a(l) {
      let { c: o } = this;
      return new Ct(l, o.d, o.h);
    }
    /**
     * Parses the XML input.
     */
    parse() {
      if (this.c.b("\uFEFF"), this.O(), !this.E())
        throw this.a("Root element is missing or invalid");
      for (; this.z(); )
        ;
      if (!this.c.B)
        throw this.a("Extra content at the end of the document");
    }
    /**
     * Throws an invalid character error if any character in the given _string_
     * isn't a valid XML character.
     */
    o(l) {
      let { length: o } = l;
      for (let h = 0; h < o; ++h) {
        let f = l.codePointAt(h);
        if (!z(f))
          throw this.c.n(-([...l].length - h)), this.a("Invalid character");
        f > 65535 && (h += 1);
      }
    }
  };
  function Q(l) {
    let o = 0;
    for (; (o = l.indexOf("\r", o)) !== -1; )
      l = l[o + 1] === `
` ? l.slice(0, o) + l.slice(o + 1) : l.slice(0, o) + `
` + l.slice(o + 1);
    return l;
  }
  function Gt(l, o) {
    return new Yt(l, o).document;
  }
  return Zt;
}
var qr = jr();
function Vr(e) {
  const t = String(e), n = [];
  return { toOffset: r, toPoint: i };
  function i(s) {
    if (typeof s == "number" && s > -1 && s <= t.length) {
      let a = 0;
      for (; ; ) {
        let c = n[a];
        if (c === void 0) {
          const u = Ne(t, n[a - 1]);
          c = u === -1 ? t.length + 1 : u + 1, n[a] = c;
        }
        if (c > s)
          return {
            line: a + 1,
            column: s - (a > 0 ? n[a - 1] : 0) + 1,
            offset: s
          };
        a++;
      }
    }
  }
  function r(s) {
    if (s && typeof s.line == "number" && typeof s.column == "number" && !Number.isNaN(s.line) && !Number.isNaN(s.column)) {
      for (; n.length < s.line; ) {
        const c = n[n.length - 1], u = Ne(t, c), d = u === -1 ? t.length + 1 : u + 1;
        if (c === d) break;
        n.push(d);
      }
      const a = (s.line > 1 ? n[s.line - 2] : 0) + s.column - 1;
      if (a < n[s.line - 1]) return a;
    }
  }
}
function Ne(e, t) {
  const n = e.indexOf("\r", t), i = e.indexOf(`
`, t);
  return i === -1 ? n : n === -1 || n + 1 === i ? i : n < i ? n : i;
}
function Wr(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Oe(e.position) : "start" in e || "end" in e ? Oe(e) : "line" in e || "column" in e ? ae(e) : "";
}
function ae(e) {
  return Ie(e && e.line) + ":" + Ie(e && e.column);
}
function Oe(e) {
  return ae(e && e.start) + "-" + ae(e && e.end);
}
function Ie(e) {
  return e && typeof e == "number" ? e : 1;
}
class B extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, i) {
    super(), typeof n == "string" && (i = n, n = void 0);
    let r = "", s = {}, a = !1;
    if (n && ("line" in n && "column" in n ? s = { place: n } : "start" in n && "end" in n ? s = { place: n } : "type" in n ? s = {
      ancestors: [n],
      place: n.position
    } : s = { ...n }), typeof t == "string" ? r = t : !s.cause && t && (a = !0, r = t.message, s.cause = t), !s.ruleId && !s.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? s.ruleId = i : (s.source = i.slice(0, u), s.ruleId = i.slice(u + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const u = s.ancestors[s.ancestors.length - 1];
      u && (s.place = u.position);
    }
    const c = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = c ? c.column : void 0, this.fatal = void 0, this.file = "", this.message = r, this.line = c ? c.line : void 0, this.name = Wr(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = a && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
B.prototype.file = "";
B.prototype.name = "";
B.prototype.reason = "";
B.prototype.message = "";
B.prototype.stack = "";
B.prototype.column = void 0;
B.prototype.line = void 0;
B.prototype.ancestors = void 0;
B.prototype.cause = void 0;
B.prototype.fatal = void 0;
B.prototype.place = void 0;
B.prototype.ruleId = void 0;
B.prototype.source = void 0;
function Yr(e) {
  const t = Vr(e);
  let n;
  try {
    n = qr.parseXml(String(e), {
      // Positional offsets.
      includeOffsets: !0,
      // `<![CDATA[>&<]]>`
      preserveCdata: !0,
      // `<!--a-->`
      preserveComments: !0,
      // `<!DOCTYPE b>` (a specific declaration)
      preserveDocumentType: !0,
      // `<?xml?>` (a specific instruction)
      preserveXmlDeclaration: !0
    });
  } catch (s) {
    const a = (
      /** @type {XmlError} */
      s
    ), c = t.toPoint(a.pos), u = new B(
      "Could not parse XML with `@rgrove/parse-xml`",
      {
        cause: a,
        place: c,
        ruleId: "error",
        source: "xast-util-from-xml"
      }
    );
    throw u.fatal = !0, u.url = "https://github.com/syntax-tree/xast-util-from-xml#throws", u;
  }
  const i = { location: t }, r = Qr(n, i);
  return yn(n, r, i), r;
}
function Gr(e) {
  return { type: "cdata", value: e.text };
}
function Zr(e) {
  return { type: "comment", value: e.content };
}
function Qr(e, t) {
  return { type: "root", children: gn(e.children, t) };
}
function ti(e) {
  return {
    type: "doctype",
    name: e.name,
    public: e.publicId || void 0,
    system: e.systemId || void 0
  };
}
function ei(e, t) {
  const n = gn(e.children, t);
  return {
    type: "element",
    name: e.name,
    attributes: { ...e.attributes },
    // @ts-expect-error: assume content matches.
    children: n
  };
}
function ni(e) {
  return { type: "instruction", name: e.name, value: e.content };
}
function ri(e) {
  return { type: "text", value: e.text };
}
function ii(e) {
  const t = [];
  return e.version && t.push('version="' + e.version + '"'), e.encoding && t.push('encoding="' + e.encoding + '"'), e.standalone && t.push('standalone="' + e.standalone + '"'), { type: "instruction", name: "xml", value: t.join(" ") };
}
function gn(e, t) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const r = e[i];
    let s;
    r.type === "cdata" ? s = Gr(
      /** @type {XmlCdata} */
      r
    ) : r.type === "comment" ? s = Zr(
      /** @type {XmlComment} */
      r
    ) : r.type === "doctype" ? s = ti(
      /** @type {XmlDocumentType} */
      r
    ) : r.type === "element" ? s = ei(
      /** @type {XmlElement} */
      r,
      t
    ) : r.type === "pi" ? s = ni(
      /** @type {XmlProcessingInstruction} */
      r
    ) : r.type === "text" ? s = ri(
      /** @type {XmlText} */
      r
    ) : r.type === "xmldecl" && (s = ii(
      /** @type {XmlDeclaration} */
      r
    )), s && (yn(r, s, t), n.push(s));
  }
  return n;
}
function yn(e, t, n) {
  const i = (
    // Doesn’t practically happen as far as I found, but `-1` is used in the
    // code, so let’s keep it in.
    /* c8 ignore next */
    e.start === -1 ? void 0 : n.location.toPoint(e.start)
  ), r = (
    // Same as above
    /* c8 ignore next */
    e.end === -1 ? void 0 : n.location.toPoint(e.end)
  );
  i && r && (t.position = { start: i, end: r });
}
const si = /["&'<>`]/g, oi = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, li = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), ai = /[|\\{}()[\]^$+*?.]/g, Me = /* @__PURE__ */ new WeakMap();
function ci(e, t) {
  if (e = e.replace(
    t.subset ? ui(t.subset) : si,
    i
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(oi, n).replace(li, i);
  function n(r, s, a) {
    return t.format(
      (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(s + 2),
      t
    );
  }
  function i(r, s, a) {
    return t.format(
      r.charCodeAt(0),
      a.charCodeAt(s + 1),
      t
    );
  }
}
function ui(e) {
  let t = Me.get(e);
  return t || (t = hi(e), Me.set(e, t)), t;
}
function hi(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(ai, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
function di(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function fi(e, t) {
  return ci(e, Object.assign({ format: di }, t));
}
const pi = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;
function vt(e, t, n) {
  const i = mi(e);
  return n ? i.replace(n, r) : r(i);
  function r(s) {
    return fi(s, { subset: t });
  }
}
function mi(e) {
  return String(e || "").replace(pi, "");
}
const gi = /]]>/g, yi = [">"];
function wi(e) {
  return "<![CDATA[" + vt(e.value, yi, gi) + "]]>";
}
function bi(e) {
  return "<!--" + vt(e.value, ["-"]) + "-->";
}
const vi = ["	", `
`, " ", '"', "&", "'", "/", "<", "=", ">"];
function Ft(e) {
  return vt(e, vi);
}
function Le(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let i = 0, r = n.indexOf(t);
  for (; r !== -1; )
    i++, r = n.indexOf(t, r + t.length);
  return i;
}
function ce(e, t) {
  const n = String(e);
  let i = t.options.quote || '"';
  if (t.options.quoteSmart) {
    const r = i === '"' ? "'" : '"';
    Le(n, i) > Le(n, r) && (i = r);
  }
  return i + vt(n, ["<", "&", i]) + i;
}
function xi(e, t) {
  const n = Ft(e.name), i = e.public, r = e.system;
  let s = "<!DOCTYPE";
  return n !== "" && (s += " " + n), i ? s += " PUBLIC " + ce(i, t) : r && (s += " SYSTEM"), r && (s += " " + ce(r, t)), s + ">";
}
const Ei = {}.hasOwnProperty;
function Ti(e, t) {
  const n = Ft(e.name), i = vn(e, t), r = e.attributes || {}, s = i ? !1 : t.options.closeEmptyElements, a = [];
  let c;
  for (c in r)
    if (Ei.call(r, c)) {
      const u = r[c];
      u != null && a.push(Ft(c) + "=" + ce(u, t));
    }
  return "<" + n + (a.length === 0 ? "" : " " + a.join(" ")) + (s ? (t.options.tightClose ? "" : " ") + "/" : "") + ">" + i + (s ? "" : "</" + n + ">");
}
const Si = /\?>/g, ki = [">"];
function Ci(e) {
  const t = Ft(e.name) || "x", n = vt(e.value, ki, Si);
  return "<?" + t + (n ? " " + n : "") + "?>";
}
const Ni = ["&", "<"];
function wn(e) {
  return vt(e.value, Ni);
}
function Oi(e, t) {
  return t.options.allowDangerousXml ? e.value : wn(e);
}
const Ii = {}.hasOwnProperty, $e = {
  cdata: wi,
  comment: bi,
  doctype: xi,
  element: Ti,
  instruction: Ci,
  raw: Oi,
  root: vn,
  text: wn
};
function bn(e, t) {
  const n = e && e.type;
  if (!n)
    throw new Error("Expected node, not `" + e + "`");
  if (!Ii.call($e, n))
    throw new Error("Cannot compile unknown node `" + n + "`");
  const i = $e[n];
  return i(e, t);
}
function vn(e, t) {
  const n = e && e.children || [];
  let i = -1;
  const r = [];
  for (; ++i < n.length; )
    r[i] = bn(n[i], t);
  return r.join("");
}
function Ae(e, t) {
  const n = { options: {} };
  if (typeof n.options.quote == "string" && n.options.quote !== '"' && n.options.quote !== "'")
    throw new Error(
      "Invalid quote `" + n.options.quote + "`, expected `'` or `\"`"
    );
  const i = Array.isArray(e) ? { type: "root", children: e } : e;
  return bn(i, n);
}
const xn = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return Ai;
    if (typeof e == "function")
      return qt(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Mi(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        Li(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return $i(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function Mi(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = xn(e[n]);
  return qt(i);
  function i(...r) {
    let s = -1;
    for (; ++s < t.length; )
      if (t[s].apply(this, r)) return !0;
    return !1;
  }
}
function Li(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return qt(n);
  function n(i) {
    const r = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let s;
    for (s in e)
      if (r[s] !== t[s]) return !1;
    return !0;
  }
}
function $i(e) {
  return qt(t);
  function t(n) {
    return n && n.type === e;
  }
}
function qt(e) {
  return t;
  function t(n, i, r) {
    return !!(Ri(n) && e.call(
      this,
      n,
      typeof i == "number" ? i : void 0,
      r || void 0
    ));
  }
}
function Ai() {
  return !0;
}
function Ri(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const En = [], Di = !0, Re = !1, Tn = "skip";
function zi(e, t, n, i) {
  let r;
  typeof t == "function" && typeof n != "function" ? (i = n, n = t) : r = t;
  const s = xn(r), a = i ? -1 : 1;
  c(e, void 0, [])();
  function c(u, d, p) {
    const m = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof m.type == "string") {
      const y = (
        // `hast`
        typeof m.tagName == "string" ? m.tagName : (
          // `xast`
          typeof m.name == "string" ? m.name : void 0
        )
      );
      Object.defineProperty(w, "name", {
        value: "node (" + (u.type + (y ? "<" + y + ">" : "")) + ")"
      });
    }
    return w;
    function w() {
      let y = En, b, E, S;
      if ((!t || s(u, d, p[p.length - 1] || void 0)) && (y = Pi(n(u, p)), y[0] === Re))
        return y;
      if ("children" in u && u.children) {
        const T = (
          /** @type {UnistParent} */
          u
        );
        if (T.children && y[0] !== Tn)
          for (E = (i ? T.children.length : -1) + a, S = p.concat(T); E > -1 && E < T.children.length; ) {
            const P = T.children[E];
            if (b = c(P, E, S)(), b[0] === Re)
              return b;
            E = typeof b[1] == "number" ? b[1] : E + a;
          }
      }
      return y;
    }
  }
}
function Pi(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Di, e] : e == null ? En : [e];
}
function Hi(e, t, n, i) {
  let r, s, a;
  typeof t == "function" && typeof n != "function" ? (s = void 0, a = t, r = n) : (s = t, a = n, r = i), zi(e, s, c, r);
  function c(u, d) {
    const p = d[d.length - 1], m = p ? p.children.indexOf(u) : void 0;
    return a(u, m, p);
  }
}
const Ui = [
  "theorem",
  "lemma",
  "corollary",
  "proposition",
  "claim",
  "fact",
  "proof"
], Bi = [
  "convention",
  "insight",
  "note",
  "observation",
  "remark",
  "warning"
], _i = [
  "assumption",
  "axiom",
  "conjecture",
  "heuristic",
  "hypothesis",
  "principle"
], Ji = [
  "introduction",
  "conclusion",
  "part",
  "chapter",
  "section",
  "subsection",
  "worksheet"
], Fi = ["example", "question", "problem"], Xi = ["solution", "answer", "hint"], Ki = [
  "ptxdoc",
  "p",
  "m",
  "me",
  "md",
  "ol",
  "ul",
  "li",
  ...Ji,
  "title",
  "definition",
  "statement",
  ...Ui,
  ..._i,
  ...Bi,
  ...Fi,
  ...Xi,
  "term",
  "em",
  "alert",
  "c",
  "pre",
  "url"
];
function ji(e) {
  let t = e.trim();
  if (t.startsWith("<?xml")) {
    const r = t.indexOf("?>");
    r !== -1 && (t = t.slice(r + 2).trim());
  }
  t = `<ptxdoc>
${t}
</ptxdoc>`;
  const n = Yr(t);
  return console.log("xast before: ", n), Hi(n, (r, s, a) => {
    if (r.type === "element" && !Ki.includes(r.name)) {
      const c = {
        type: "element",
        name: "rawptx",
        attributes: {},
        children: [
          //{type: "text", value: '\n'},
          { type: "text", value: Ae(r) }
          //{type: "text", value: '\n'},
        ]
      };
      return typeof s != "number" || !a ? void 0 : (a.children.splice(s, 1, c), Tn);
    }
  }), console.log("xast after: ", n), Ae(n);
}
function qi() {
  return {
    label: {
      parseHTML: (e) => e.getAttribute("label")
    },
    "xml:id": {
      parseHTML: (e) => e.getAttribute("xml:id")
    },
    component: {
      parseHTML: (e) => e.getAttribute("component")
    }
  };
}
function rt(e, t) {
  return [
    st({
      find: new RegExp(`^#${e}\\s$`, "i"),
      type: t
    }),
    st({
      find: new RegExp(`(?:^)(<${e}>(\\s))$`, "i"),
      type: t
    }),
    st({
      find: new RegExp(`(?:^)(${e}:(\\s))$`, "i"),
      type: t
    })
  ];
}
const Vi = [
  "theorem",
  "lemma",
  "corollary",
  "proposition",
  "claim",
  "fact"
], Wi = G.create({
  name: "theoremLike",
  addExtensions() {
    const e = [];
    for (const t of Vi)
      e.push(
        A.create({
          name: t,
          content: "title? statement proof*",
          group: "block theoremLike",
          selectable: !0,
          draggable: !0,
          defining: !1,
          parseHTML() {
            return [
              {
                tag: t
              }
            ];
          },
          addAttributes() {
            return qi();
          },
          renderHTML({ HTMLAttributes: n }) {
            return [
              "article",
              L(
                { class: `${t} theorem-like`, ptxtag: t },
                n
                // Include all attributes from the node
              )
            ];
          },
          addNodeView() {
            return pt(Rt);
          },
          addInputRules() {
            return rt(t, this.type);
          }
        })
      );
    return e.push(
      A.create({
        name: "proof",
        content: "title? BasicBlock+",
        group: "block",
        selectable: !0,
        draggable: !0,
        parseHTML() {
          return [{ tag: "proof" }];
        },
        renderHTML({ HTMLAttributes: t }) {
          return [
            "article",
            L(
              { class: "proof", ptxtag: "proof" },
              t
              // Include all attributes from the node
            ),
            0
          ];
        },
        addNodeView() {
          return pt(fn);
        },
        addInputRules() {
          return rt("proof", this.type);
        }
      })
    ), e;
  }
}), Yi = [
  "assumption",
  "axiom",
  "conjecture",
  "heuristic",
  "hypothesis",
  "principle"
], Gi = G.create({
  name: "axiomLike",
  addExtensions() {
    const e = [];
    for (const t of Yi)
      e.push(
        A.create({
          name: t,
          content: "title? statement",
          group: "block axiomLike",
          selectable: !0,
          draggable: !0,
          parseHTML() {
            return [
              {
                tag: t
              }
            ];
          },
          renderHTML({ HTMLAttributes: n }) {
            return [
              "article",
              L(
                { class: `${t} axiom-like`, label: t },
                n
              ),
              0
            ];
          },
          addNodeView() {
            return pt(Rt);
          },
          addInputRules() {
            return rt(t, this.type);
          }
        })
      );
    return e;
  }
}), Zi = A.create({
  name: "statement",
  content: "BasicBlock+",
  group: "blockContent",
  parseHTML() {
    return [{ tag: "statement" }];
  },
  renderHTML() {
    return ["div", { class: "statement", ptxtag: "statement" }, 0];
  },
  addInputRules() {
    return rt("statement", this.type);
  }
}), Qi = ["example", "question", "problem"], ts = G.create({
  name: "exampleLike",
  addExtensions() {
    const e = [];
    for (const t of Qi)
      e.push(
        A.create({
          name: t,
          content: "title? (BasicBlock*|(statement hint* answer* solution*))",
          group: "block exampleLike",
          selectable: !0,
          draggable: !0,
          defining: !1,
          parseHTML() {
            return [
              {
                tag: t
              }
            ];
          },
          addAttributes() {
            return {
              label: {
                parseHTML: (n) => n.getAttribute("label")
              },
              "xml:id": {
                parseHTML: (n) => n.getAttribute("xml:id")
              },
              component: {
                parseHTML: (n) => n.getAttribute("component")
              }
            };
          },
          renderHTML({ HTMLAttributes: n }) {
            return [
              "article",
              L(
                { class: `${t} theorem-like`, ptxtag: t },
                n
                // Include all attributes from the node
              )
            ];
          },
          addNodeView() {
            return pt(Rt);
          },
          addInputRules() {
            return rt(t, this.type);
          }
        })
      );
    for (const t of ["hint", "answer", "solution"])
      e.push(
        A.create({
          name: t,
          content: "title? BasicBlock+",
          group: "block solutionLike",
          selectable: !0,
          draggable: !0,
          defining: !1,
          parseHTML() {
            return [
              {
                tag: t
              }
            ];
          },
          addAttributes() {
            return {
              label: {
                parseHTML: (n) => n.getAttribute("label")
              },
              "xml:id": {
                parseHTML: (n) => n.getAttribute("xml:id")
              },
              component: {
                parseHTML: (n) => n.getAttribute("component")
              }
            };
          },
          renderHTML({ HTMLAttributes: n }) {
            return [
              "article",
              L(
                { class: "proof", ptxtag: "proof" },
                n
                // Include all attributes from the node
              ),
              0
            ];
          },
          addNodeView() {
            return pt(fn);
          },
          addInputRules() {
            return rt("proof", this.type);
          }
        })
      );
    return e;
  }
}), es = [
  "convention",
  "insight",
  "note",
  "observation",
  "remark",
  "warning"
], ns = G.create({
  name: "remarkLike",
  addExtensions() {
    return es.map(
      (e) => A.create({
        name: e,
        content: "title? BasicBlock+",
        group: "block remarkLike",
        selectable: !0,
        draggable: !0,
        parseHTML() {
          return [
            {
              tag: e
            }
          ];
        },
        renderHTML({ HTMLAttributes: t }) {
          return [
            "article",
            L(
              { class: `${e} remark-like`, label: e },
              t
            ),
            0
          ];
        },
        addNodeView() {
          return pt(Rt);
        },
        addInputRules() {
          return rt(e, this.type);
        }
      })
    );
  }
}), rs = A.create({
  name: "p",
  content: "inline*",
  group: "BasicBlock paragraph",
  //   selectable: false,
  draggable: !0,
  defining: !1,
  priority: 1e3,
  parseHTML() {
    return [
      {
        tag: "p"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "div",
      L({ class: "p", ptxtag: "p" }, e),
      0
    ];
  },
  addInputRules() {
    return [
      st({
        find: new RegExp("^#p\\s$"),
        type: this.type
      })
    ];
  }
}), is = G.create({
  name: "blocks",
  addExtensions() {
    return [rs, Wi, ts, Gi, ns, Zi];
  }
}), ss = A.create({
  name: "title",
  content: "text*",
  // defining: true,
  parseHTML() {
    return [{ tag: "title" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "div",
      L({ class: "title", ptxtag: "title" }, e),
      0
    ];
  },
  //addCommands() {
  //  return {
  //    setNode:
  //      (attributes) =>
  //      ({ commands }) => {
  //        return commands.setNode(this.name, attributes);
  //      },
  //    toggleNode:
  //      (attributes) =>
  //      ({ commands }) => {
  //        return commands.toggleNode(this.name, "para", attributes);
  //      },
  //  };
  //},
  addInputRules() {
    return [
      vr({
        find: new RegExp("#t\\s$"),
        type: this.type
      }),
      ...rt("title", this.type)
    ];
  }
}), os = A.create({
  name: "definition",
  content: "title? statement",
  group: "block definitionLike",
  selectable: !0,
  draggable: !0,
  defining: !1,
  // This would make it so an extra delete would not delete the parent node.  Not sure how we would end up deleting it.
  // isolating: true,
  parseHTML() {
    return [
      {
        tag: "definition"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "article",
      L(
        { class: "definition definition-like", label: "definition" },
        e
      ),
      0
    ];
  },
  addNodeView() {
    return pt(Rt);
  },
  addInputRules() {
    return rt("definition", this.type);
  }
}), ls = A.create({
  name: "url",
  content: "text*",
  group: "inline",
  inline: !0,
  atom: !1,
  parseHTML() {
    return [
      {
        tag: "url"
      }
    ];
  },
  addAttributes() {
    return {
      href: {
        parseHTML: (e) => e.getAttribute("href")
      }
    };
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "a",
      L({ ptxtag: "url" }, e),
      0
    ];
  }
}), as = A.create({
  name: "rawptx",
  content: "text*",
  marks: "",
  selectable: !0,
  draggable: !0,
  defining: !0,
  code: !0,
  whitespace: "pre",
  parseHTML() {
    return [
      {
        tag: "rawptx",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "pre",
      L({ class: "rawptx", ptxtag: "rawptx" }, e),
      0
    ];
  }
}), Dt = {
  para: "p",
  bulletList: "ul",
  orderedList: "ol",
  listItem: "li",
  italic: "em"
};
function De(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function cs(e) {
  let t = "";
  return e.type !== "ptxFragment" ? (console.log("Top level node is not a ptxFragment"), "") : e.content ? e.content.length !== 1 ? (console.log("More than one child in json.content"), "") : (t += Sn(e.content[0]), t = t.replace(/^<ptxdoc>\s*/, `
`).replace(/\s*<\/ptxdoc>/, ""), t) : (console.log("No content in json"), "");
}
function Sn(e) {
  let t = "";
  if (e.content) {
    const n = e.type in Dt ? Dt[e.type] : e.type, i = e.attrs;
    if (n === "rawptx")
      for (const r of e.content)
        r.type !== "text" && console.log(
          "Unexpected non-text node inside rawptx: " + JSON.stringify(r)
        ), t = t + r.text;
    else {
      if (t = t + "<" + n, i)
        for (const [r, s] of Object.entries(i))
          s !== null && (t = t + " " + r + '="' + s + '"');
      t = t + `>
`;
      for (const r of e.content)
        t = t + Sn(r);
      t = t + `
</` + n + `>
`;
    }
  } else if (e.type === "text")
    if (e.marks) {
      const n = e.marks[0].type in Dt ? Dt[e.marks[0].type] : e.marks[0].type;
      t = t + "<" + n + ">" + De(e.text || "") + "</" + n + ">";
    } else
      t = t + De(e.text || "");
  else e.type === "hardBreak" ? t = t + `
` : t = t + "<!-- Something is missing; got " + JSON.stringify(e) + " -->";
  return t;
}
function kn(e, t, n) {
  for (let i = 0; ; i++) {
    if (i == e.childCount || i == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let r = e.child(i), s = t.child(i);
    if (r == s) {
      n += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(s))
      return n;
    if (r.isText && r.text != s.text) {
      for (let a = 0; r.text[a] == s.text[a]; a++)
        n++;
      return n;
    }
    if (r.content.size || s.content.size) {
      let a = kn(r.content, s.content, n + 1);
      if (a != null)
        return a;
    }
    n += r.nodeSize;
  }
}
function Cn(e, t, n, i) {
  for (let r = e.childCount, s = t.childCount; ; ) {
    if (r == 0 || s == 0)
      return r == s ? null : { a: n, b: i };
    let a = e.child(--r), c = t.child(--s), u = a.nodeSize;
    if (a == c) {
      n -= u, i -= u;
      continue;
    }
    if (!a.sameMarkup(c))
      return { a: n, b: i };
    if (a.isText && a.text != c.text) {
      let d = 0, p = Math.min(a.text.length, c.text.length);
      for (; d < p && a.text[a.text.length - d - 1] == c.text[c.text.length - d - 1]; )
        d++, n--, i--;
      return { a: n, b: i };
    }
    if (a.content.size || c.content.size) {
      let d = Cn(a.content, c.content, n - 1, i - 1);
      if (d)
        return d;
    }
    n -= u, i -= u;
  }
}
class I {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let i = 0; i < t.length; i++)
        this.size += t[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, i, r = 0, s) {
    for (let a = 0, c = 0; c < n; a++) {
      let u = this.content[a], d = c + u.nodeSize;
      if (d > t && i(u, r + c, s || null, a) !== !1 && u.content.size) {
        let p = c + 1;
        u.nodesBetween(Math.max(0, t - p), Math.min(u.content.size, n - p), i, r + p);
      }
      c = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, i, r) {
    let s = "", a = !0;
    return this.nodesBetween(t, n, (c, u) => {
      let d = c.isText ? c.text.slice(Math.max(t, u) - u, n - u) : c.isLeaf ? r ? typeof r == "function" ? r(c) : r : c.type.spec.leafText ? c.type.spec.leafText(c) : "" : "";
      c.isBlock && (c.isLeaf && d || c.isTextblock) && i && (a ? a = !1 : s += i), s += d;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, i = t.firstChild, r = this.content.slice(), s = 0;
    for (n.isText && n.sameMarkup(i) && (r[r.length - 1] = n.withText(n.text + i.text), s = 1); s < t.content.length; s++)
      r.push(t.content[s]);
    return new I(r, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let i = [], r = 0;
    if (n > t)
      for (let s = 0, a = 0; a < n; s++) {
        let c = this.content[s], u = a + c.nodeSize;
        u > t && ((a < t || u > n) && (c.isText ? c = c.cut(Math.max(0, t - a), Math.min(c.text.length, n - a)) : c = c.cut(Math.max(0, t - a - 1), Math.min(c.content.size, n - a - 1))), i.push(c), r += c.nodeSize), a = u;
      }
    return new I(i, r);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? I.empty : t == 0 && n == this.content.length ? this : new I(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let i = this.content[t];
    if (i == n)
      return this;
    let r = this.content.slice(), s = this.size + n.nodeSize - i.nodeSize;
    return r[t] = n, new I(r, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new I([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new I(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, i = 0; n < this.content.length; n++) {
      let r = this.content[n];
      t(r, i, n), i += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return kn(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, i = t.size) {
    return Cn(this, t, n, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(t) {
    if (t == 0)
      return zt(0, t);
    if (t == this.size)
      return zt(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let n = 0, i = 0; ; n++) {
      let r = this.child(n), s = i + r.nodeSize;
      if (s >= t)
        return s == t ? zt(n + 1, s) : zt(n, i);
      i = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return I.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new I(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return I.empty;
    let n, i = 0;
    for (let r = 0; r < t.length; r++) {
      let s = t[r];
      i += s.nodeSize, r && s.isText && t[r - 1].sameMarkup(s) ? (n || (n = t.slice(0, r)), n[n.length - 1] = s.withText(n[n.length - 1].text + s.text)) : n && n.push(s);
    }
    return new I(n || t, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return I.empty;
    if (t instanceof I)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new I([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
I.empty = new I([], 0);
const Qt = { index: 0, offset: 0 };
function zt(e, t) {
  return Qt.index = e, Qt.offset = t, Qt;
}
class us extends Error {
}
class C {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, i) {
    this.content = t, this.openStart = n, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let i = On(this.content, t + this.openStart, n);
    return i && new C(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new C(Nn(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return C.empty;
    let i = n.openStart || 0, r = n.openEnd || 0;
    if (typeof i != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new C(I.fromJSON(t, n.content), i, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let i = 0, r = 0;
    for (let s = t.firstChild; s && !s.isLeaf && (n || !s.type.spec.isolating); s = s.firstChild)
      i++;
    for (let s = t.lastChild; s && !s.isLeaf && (n || !s.type.spec.isolating); s = s.lastChild)
      r++;
    return new C(t, i, r);
  }
}
C.empty = new C(I.empty, 0, 0);
function Nn(e, t, n) {
  let { index: i, offset: r } = e.findIndex(t), s = e.maybeChild(i), { index: a, offset: c } = e.findIndex(n);
  if (r == t || s.isText) {
    if (c != n && !e.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (i != a)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(i, s.copy(Nn(s.content, t - r - 1, n - r - 1)));
}
function On(e, t, n, i) {
  let { index: r, offset: s } = e.findIndex(t), a = e.maybeChild(r);
  if (s == t || a.isText)
    return i && !i.canReplace(r, r, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
  let c = On(a.content, t - s - 1, n, a);
  return c && e.replaceChild(r, a.copy(c));
}
const In = 65535, Mn = Math.pow(2, 16);
function hs(e, t) {
  return e + t * Mn;
}
function ze(e) {
  return e & In;
}
function ds(e) {
  return (e - (e & In)) / Mn;
}
const Ln = 1, $n = 2, _t = 4, An = 8;
class Pe {
  /**
  @internal
  */
  constructor(t, n, i) {
    this.pos = t, this.delInfo = n, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & An) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Ln | _t)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & ($n | _t)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & _t) > 0;
  }
}
class X {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && X.empty)
      return X.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, i = ze(t);
    if (!this.inverted)
      for (let r = 0; r < i; r++)
        n += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[i * 3] + n + ds(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, i) {
    let r = 0, s = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let c = 0; c < this.ranges.length; c += 3) {
      let u = this.ranges[c] - (this.inverted ? r : 0);
      if (u > t)
        break;
      let d = this.ranges[c + s], p = this.ranges[c + a], m = u + d;
      if (t <= m) {
        let w = d ? t == u ? -1 : t == m ? 1 : n : n, y = u + r + (w < 0 ? 0 : p);
        if (i)
          return y;
        let b = t == (n < 0 ? u : m) ? null : hs(c / 3, t - u), E = t == u ? $n : t == m ? Ln : _t;
        return (n < 0 ? t != u : t != m) && (E |= An), new Pe(y, E, b);
      }
      r += p - d;
    }
    return i ? t + r : new Pe(t + r, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let i = 0, r = ze(n), s = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let c = 0; c < this.ranges.length; c += 3) {
      let u = this.ranges[c] - (this.inverted ? i : 0);
      if (u > t)
        break;
      let d = this.ranges[c + s], p = u + d;
      if (t <= p && c == r * 3)
        return !0;
      i += this.ranges[c + a] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let r = 0, s = 0; r < this.ranges.length; r += 3) {
      let a = this.ranges[r], c = a - (this.inverted ? s : 0), u = a + (this.inverted ? 0 : s), d = this.ranges[r + n], p = this.ranges[r + i];
      t(c, c + d, u, u + p), s += p - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new X(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? X.empty : new X(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
X.empty = new X([]);
const te = /* @__PURE__ */ Object.create(null);
class U {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return X.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = te[n.stepType];
    if (!i)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return i.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in te)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return te[t] = n, n.prototype.jsonID = t, n;
  }
}
class D {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new D(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new D(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, i, r) {
    try {
      return D.ok(t.replace(n, i, r));
    } catch (s) {
      if (s instanceof us)
        return D.fail(s.message);
      throw s;
    }
  }
}
function be(e, t, n) {
  let i = [];
  for (let r = 0; r < e.childCount; r++) {
    let s = e.child(r);
    s.content.size && (s = s.copy(be(s.content, t, s))), s.isInline && (s = t(s, n, r)), i.push(s);
  }
  return I.fromArray(i);
}
class ht extends U {
  /**
  Create a mark step.
  */
  constructor(t, n, i) {
    super(), this.from = t, this.to = n, this.mark = i;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), i = t.resolve(this.from), r = i.node(i.sharedDepth(this.to)), s = new C(be(n.content, (a, c) => !a.isAtom || !c.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), r), n.openStart, n.openEnd);
    return D.fromReplace(t, this.from, this.to, s);
  }
  invert() {
    return new dt(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), i = t.mapResult(this.to, -1);
    return n.deleted && i.deleted || n.pos >= i.pos ? null : new ht(n.pos, i.pos, this.mark);
  }
  merge(t) {
    return t instanceof ht && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new ht(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new ht(n.from, n.to, t.markFromJSON(n.mark));
  }
}
U.jsonID("addMark", ht);
class dt extends U {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, i) {
    super(), this.from = t, this.to = n, this.mark = i;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), i = new C(be(n.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), t), n.openStart, n.openEnd);
    return D.fromReplace(t, this.from, this.to, i);
  }
  invert() {
    return new ht(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), i = t.mapResult(this.to, -1);
    return n.deleted && i.deleted || n.pos >= i.pos ? null : new dt(n.pos, i.pos, this.mark);
  }
  merge(t) {
    return t instanceof dt && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new dt(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new dt(n.from, n.to, t.markFromJSON(n.mark));
  }
}
U.jsonID("removeMark", dt);
class ft extends U {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return D.fail("No node at mark step's position");
    let i = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return D.fromReplace(t, this.pos, this.pos + 1, new C(I.from(i), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let i = this.mark.addToSet(n.marks);
      if (i.length == n.marks.length) {
        for (let r = 0; r < n.marks.length; r++)
          if (!n.marks[r].isInSet(i))
            return new ft(this.pos, n.marks[r]);
        return new ft(this.pos, this.mark);
      }
    }
    return new Lt(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new ft(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new ft(n.pos, t.markFromJSON(n.mark));
  }
}
U.jsonID("addNodeMark", ft);
class Lt extends U {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return D.fail("No node at mark step's position");
    let i = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return D.fromReplace(t, this.pos, this.pos + 1, new C(I.from(i), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new ft(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Lt(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Lt(n.pos, t.markFromJSON(n.mark));
  }
}
U.jsonID("removeNodeMark", Lt);
class W extends U {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, i, r = !1) {
    super(), this.from = t, this.to = n, this.slice = i, this.structure = r;
  }
  apply(t) {
    return this.structure && ue(t, this.from, this.to) ? D.fail("Structure replace would overwrite content") : D.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new X([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new W(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.to, -1), i = this.from == this.to && W.MAP_BIAS < 0 ? n : t.mapResult(this.from, 1);
    return i.deletedAcross && n.deletedAcross ? null : new W(i.pos, Math.max(i.pos, n.pos), this.slice, this.structure);
  }
  merge(t) {
    if (!(t instanceof W) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? C.empty : new C(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new W(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? C.empty : new C(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new W(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new W(n.from, n.to, C.fromJSON(t, n.slice), !!n.structure);
  }
}
W.MAP_BIAS = 1;
U.jsonID("replace", W);
class wt extends U {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, i, r, s, a, c = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = i, this.gapTo = r, this.slice = s, this.insert = a, this.structure = c;
  }
  apply(t) {
    if (this.structure && (ue(t, this.from, this.gapFrom) || ue(t, this.gapTo, this.to)))
      return D.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return D.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, n.content);
    return i ? D.fromReplace(t, this.from, this.to, i) : D.fail("Content does not fit in gap");
  }
  getMap() {
    return new X([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new wt(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), i = t.mapResult(this.to, -1), r = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), s = this.to == this.gapTo ? i.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && i.deletedAcross || r < n.pos || s > i.pos ? null : new wt(n.pos, i.pos, r, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new wt(n.from, n.to, n.gapFrom, n.gapTo, C.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
U.jsonID("replaceAround", wt);
function ue(e, t, n) {
  let i = e.resolve(t), r = n - t, s = i.depth;
  for (; r > 0 && s > 0 && i.indexAfter(s) == i.node(s).childCount; )
    s--, r--;
  if (r > 0) {
    let a = i.node(s).maybeChild(i.indexAfter(s));
    for (; r > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, r--;
    }
  }
  return !1;
}
class It extends U {
  /**
  Construct an attribute step.
  */
  constructor(t, n, i) {
    super(), this.pos = t, this.attr = n, this.value = i;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return D.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let s in n.attrs)
      i[s] = n.attrs[s];
    i[this.attr] = this.value;
    let r = n.type.create(i, null, n.marks);
    return D.fromReplace(t, this.pos, this.pos + 1, new C(I.from(r), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return X.empty;
  }
  invert(t) {
    return new It(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new It(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new It(n.pos, n.attr, n.value);
  }
}
U.jsonID("attr", It);
class Xt extends U {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      n[r] = t.attrs[r];
    n[this.attr] = this.value;
    let i = t.type.create(n, t.content, t.marks);
    return D.ok(i);
  }
  getMap() {
    return X.empty;
  }
  invert(t) {
    return new Xt(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Xt(n.attr, n.value);
  }
}
U.jsonID("docAttr", Xt);
let $t = class extends Error {
};
$t = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
$t.prototype = Object.create(Error.prototype);
$t.prototype.constructor = $t;
$t.prototype.name = "TransformError";
const ee = /* @__PURE__ */ Object.create(null);
class M {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, i) {
    this.$anchor = t, this.$head = n, this.ranges = i || [new Rn(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = C.empty) {
    let i = n.content.lastChild, r = null;
    for (let c = 0; c < n.openEnd; c++)
      r = i, i = i.lastChild;
    let s = t.steps.length, a = this.ranges;
    for (let c = 0; c < a.length; c++) {
      let { $from: u, $to: d } = a[c], p = t.mapping.slice(s);
      t.replaceRange(p.map(u.pos), p.map(d.pos), c ? C.empty : n), c == 0 && Be(t, s, (i ? i.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let i = t.steps.length, r = this.ranges;
    for (let s = 0; s < r.length; s++) {
      let { $from: a, $to: c } = r[s], u = t.mapping.slice(i), d = u.map(a.pos), p = u.map(c.pos);
      s ? t.deleteRange(d, p) : (t.replaceRangeWith(d, p, n), Be(t, i, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, i = !1) {
    let r = t.parent.inlineContent ? new q(t) : yt(t.node(0), t.parent, t.pos, t.index(), n, i);
    if (r)
      return r;
    for (let s = t.depth - 1; s >= 0; s--) {
      let a = n < 0 ? yt(t.node(0), t.node(s), t.before(s + 1), t.index(s), n, i) : yt(t.node(0), t.node(s), t.after(s + 1), t.index(s) + 1, n, i);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new nt(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return yt(t, t, 0, 0, 1) || new nt(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return yt(t, t, t.content.size, t.childCount, -1) || new nt(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = ee[n.type];
    if (!i)
      throw new RangeError(`No selection type ${n.type} defined`);
    return i.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in ee)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return ee[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return q.between(this.$anchor, this.$head).getBookmark();
  }
}
M.prototype.visible = !0;
class Rn {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let He = !1;
function Ue(e) {
  !He && !e.parent.inlineContent && (He = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class q extends M {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    Ue(t), Ue(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let i = t.resolve(n.map(this.head));
    if (!i.parent.inlineContent)
      return M.near(i);
    let r = t.resolve(n.map(this.anchor));
    return new q(r.parent.inlineContent ? r : i, i);
  }
  replace(t, n = C.empty) {
    if (super.replace(t, n), n == C.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && t.ensureMarks(i);
    }
  }
  eq(t) {
    return t instanceof q && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new Vt(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new q(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, i = n) {
    let r = t.resolve(n);
    return new this(r, i == n ? r : t.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, i) {
    let r = t.pos - n.pos;
    if ((!i || r) && (i = r >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let s = M.findFrom(n, i, !0) || M.findFrom(n, -i, !0);
      if (s)
        n = s.$head;
      else
        return M.near(n, i);
    }
    return t.parent.inlineContent || (r == 0 ? t = n : (t = (M.findFrom(t, -i, !0) || M.findFrom(t, i, !0)).$anchor, t.pos < n.pos != r < 0 && (t = n))), new q(t, n);
  }
}
M.jsonID("text", q);
class Vt {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new Vt(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return q.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class V extends M {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, i = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, i), this.node = n;
  }
  map(t, n) {
    let { deleted: i, pos: r } = n.mapResult(this.anchor), s = t.resolve(r);
    return i ? M.near(s) : new V(s);
  }
  content() {
    return new C(I.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof V && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new ve(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new V(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new V(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
V.prototype.visible = !1;
M.jsonID("node", V);
class ve {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: i } = t.mapResult(this.anchor);
    return n ? new Vt(i, i) : new ve(i);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), i = n.nodeAfter;
    return i && V.isSelectable(i) ? new V(n) : M.near(n);
  }
}
class nt extends M {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = C.empty) {
    if (n == C.empty) {
      t.delete(0, t.doc.content.size);
      let i = M.atStart(t.doc);
      i.eq(t.selection) || t.setSelection(i);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new nt(t);
  }
  map(t) {
    return new nt(t);
  }
  eq(t) {
    return t instanceof nt;
  }
  getBookmark() {
    return fs;
  }
}
M.jsonID("all", nt);
const fs = {
  map() {
    return this;
  },
  resolve(e) {
    return new nt(e);
  }
};
function yt(e, t, n, i, r, s = !1) {
  if (t.inlineContent)
    return q.create(e, n);
  for (let a = i - (r > 0 ? 0 : 1); r > 0 ? a < t.childCount : a >= 0; a += r) {
    let c = t.child(a);
    if (c.isAtom) {
      if (!s && V.isSelectable(c))
        return V.create(e, n - (r < 0 ? c.nodeSize : 0));
    } else {
      let u = yt(e, c, n + r, r < 0 ? c.childCount : 0, r, s);
      if (u)
        return u;
    }
    n += c.nodeSize * r;
  }
  return null;
}
function Be(e, t, n) {
  let i = e.steps.length - 1;
  if (i < t)
    return;
  let r = e.steps[i];
  if (!(r instanceof W || r instanceof wt))
    return;
  let s = e.mapping.maps[i], a;
  s.forEach((c, u, d, p) => {
    a == null && (a = p);
  }), e.setSelection(M.near(e.doc.resolve(a), n));
}
function _e(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Pt {
  constructor(t, n, i) {
    this.name = t, this.init = _e(n.init, i), this.apply = _e(n.apply, i);
  }
}
new Pt("doc", {
  init(e) {
    return e.doc || e.schema.topNodeType.createAndFill();
  },
  apply(e) {
    return e.doc;
  }
}), new Pt("selection", {
  init(e, t) {
    return e.selection || M.atStart(t.doc);
  },
  apply(e) {
    return e.selection;
  }
}), new Pt("storedMarks", {
  init(e) {
    return e.storedMarks || null;
  },
  apply(e, t, n, i) {
    return i.selection.$cursor ? e.storedMarks : null;
  }
}), new Pt("scrollToSelection", {
  init() {
    return 0;
  },
  apply(e, t) {
    return e.scrolledIntoView ? t + 1 : t;
  }
});
function Dn(e, t, n) {
  for (let i in e) {
    let r = e[i];
    r instanceof Function ? r = r.bind(t) : i == "handleDOMEvents" && (r = Dn(r, t, {})), n[i] = r;
  }
  return n;
}
class zn {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && Dn(t.props, this, this.props), this.key = t.key ? t.key.key : Pn("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const ne = /* @__PURE__ */ Object.create(null);
function Pn(e) {
  return e in ne ? e + "$" + ++ne[e] : (ne[e] = 0, e + "$");
}
class xt {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = Pn(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
var ot = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Kt = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, ps = typeof navigator < "u" && /Mac/.test(navigator.platform), ms = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var H = 0; H < 10; H++) ot[48 + H] = ot[96 + H] = String(H);
for (var H = 1; H <= 24; H++) ot[H + 111] = "F" + H;
for (var H = 65; H <= 90; H++)
  ot[H] = String.fromCharCode(H + 32), Kt[H] = String.fromCharCode(H);
for (var re in ot) Kt.hasOwnProperty(re) || (Kt[re] = ot[re]);
function gs(e) {
  var t = ps && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || ms && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? Kt : ot)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const ys = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), ws = typeof navigator < "u" && /Win/.test(navigator.platform);
function bs(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let i, r, s, a;
  for (let c = 0; c < t.length - 1; c++) {
    let u = t[c];
    if (/^(cmd|meta|m)$/i.test(u))
      a = !0;
    else if (/^a(lt)?$/i.test(u))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(u))
      r = !0;
    else if (/^s(hift)?$/i.test(u))
      s = !0;
    else if (/^mod$/i.test(u))
      ys ? a = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + u);
  }
  return i && (n = "Alt-" + n), r && (n = "Ctrl-" + n), a && (n = "Meta-" + n), s && (n = "Shift-" + n), n;
}
function vs(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[bs(n)] = e[n];
  return t;
}
function ie(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function xs(e) {
  let t = vs(e);
  return function(n, i) {
    let r = gs(i), s, a = t[ie(r, i)];
    if (a && a(n.state, n.dispatch, n))
      return !0;
    if (r.length == 1 && r != " ") {
      if (i.shiftKey) {
        let c = t[ie(r, i, !1)];
        if (c && c(n.state, n.dispatch, n))
          return !0;
      }
      if ((i.altKey || i.metaKey || i.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(ws && i.ctrlKey && i.altKey) && (s = ot[i.keyCode]) && s != r) {
        let c = t[ie(s, i)];
        if (c && c(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
let he, de;
if (typeof WeakMap < "u") {
  let e = /* @__PURE__ */ new WeakMap();
  he = (t) => e.get(t), de = (t, n) => (e.set(t, n), n);
} else {
  const e = [];
  let n = 0;
  he = (i) => {
    for (let r = 0; r < e.length; r += 2) if (e[r] == i) return e[r + 1];
  }, de = (i, r) => (n == 10 && (n = 0), e[n++] = i, e[n++] = r);
}
var et = class {
  constructor(e, t, n, i) {
    this.width = e, this.height = t, this.map = n, this.problems = i;
  }
  findCell(e) {
    for (let t = 0; t < this.map.length; t++) {
      const n = this.map[t];
      if (n != e) continue;
      const i = t % this.width, r = t / this.width | 0;
      let s = i + 1, a = r + 1;
      for (let c = 1; s < this.width && this.map[t + c] == n; c++) s++;
      for (let c = 1; a < this.height && this.map[t + this.width * c] == n; c++) a++;
      return {
        left: i,
        top: r,
        right: s,
        bottom: a
      };
    }
    throw new RangeError(`No cell with offset ${e} found`);
  }
  colCount(e) {
    for (let t = 0; t < this.map.length; t++) if (this.map[t] == e) return t % this.width;
    throw new RangeError(`No cell with offset ${e} found`);
  }
  nextCell(e, t, n) {
    const { left: i, right: r, top: s, bottom: a } = this.findCell(e);
    return t == "horiz" ? (n < 0 ? i == 0 : r == this.width) ? null : this.map[s * this.width + (n < 0 ? i - 1 : r)] : (n < 0 ? s == 0 : a == this.height) ? null : this.map[i + this.width * (n < 0 ? s - 1 : a)];
  }
  rectBetween(e, t) {
    const { left: n, right: i, top: r, bottom: s } = this.findCell(e), { left: a, right: c, top: u, bottom: d } = this.findCell(t);
    return {
      left: Math.min(n, a),
      top: Math.min(r, u),
      right: Math.max(i, c),
      bottom: Math.max(s, d)
    };
  }
  cellsInRect(e) {
    const t = [], n = {};
    for (let i = e.top; i < e.bottom; i++) for (let r = e.left; r < e.right; r++) {
      const s = i * this.width + r, a = this.map[s];
      n[a] || (n[a] = !0, !(r == e.left && r && this.map[s - 1] == a || i == e.top && i && this.map[s - this.width] == a) && t.push(a));
    }
    return t;
  }
  positionAt(e, t, n) {
    for (let i = 0, r = 0; ; i++) {
      const s = r + n.child(i).nodeSize;
      if (i == e) {
        let a = t + e * this.width;
        const c = (e + 1) * this.width;
        for (; a < c && this.map[a] < r; ) a++;
        return a == c ? s - 1 : this.map[a];
      }
      r = s;
    }
  }
  static get(e) {
    return he(e) || de(e, Es(e));
  }
};
function Es(e) {
  if (e.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + e.type.name);
  const t = Ts(e), n = e.childCount, i = [];
  let r = 0, s = null;
  const a = [];
  for (let d = 0, p = t * n; d < p; d++) i[d] = 0;
  for (let d = 0, p = 0; d < n; d++) {
    const m = e.child(d);
    p++;
    for (let b = 0; ; b++) {
      for (; r < i.length && i[r] != 0; ) r++;
      if (b == m.childCount) break;
      const E = m.child(b), { colspan: S, rowspan: T, colwidth: P } = E.attrs;
      for (let R = 0; R < T; R++) {
        if (R + d >= n) {
          (s || (s = [])).push({
            type: "overlong_rowspan",
            pos: p,
            n: T - R
          });
          break;
        }
        const z = r + R * t;
        for (let k = 0; k < S; k++) {
          i[z + k] == 0 ? i[z + k] = p : (s || (s = [])).push({
            type: "collision",
            row: d,
            pos: p,
            n: S - k
          });
          const x = P && P[k];
          if (x) {
            const J = (z + k) % t * 2, Z = a[J];
            Z == null || Z != x && a[J + 1] == 1 ? (a[J] = x, a[J + 1] = 1) : Z == x && a[J + 1]++;
          }
        }
      }
      r += S, p += E.nodeSize;
    }
    const w = (d + 1) * t;
    let y = 0;
    for (; r < w; ) i[r++] == 0 && y++;
    y && (s || (s = [])).push({
      type: "missing",
      row: d,
      n: y
    }), p++;
  }
  (t === 0 || n === 0) && (s || (s = [])).push({ type: "zero_sized" });
  const c = new et(t, n, i, s);
  let u = !1;
  for (let d = 0; !u && d < a.length; d += 2) a[d] != null && a[d + 1] < n && (u = !0);
  return u && Ss(c, a, e), c;
}
function Ts(e) {
  let t = -1, n = !1;
  for (let i = 0; i < e.childCount; i++) {
    const r = e.child(i);
    let s = 0;
    if (n) for (let a = 0; a < i; a++) {
      const c = e.child(a);
      for (let u = 0; u < c.childCount; u++) {
        const d = c.child(u);
        a + d.attrs.rowspan > i && (s += d.attrs.colspan);
      }
    }
    for (let a = 0; a < r.childCount; a++) {
      const c = r.child(a);
      s += c.attrs.colspan, c.attrs.rowspan > 1 && (n = !0);
    }
    t == -1 ? t = s : t != s && (t = Math.max(t, s));
  }
  return t;
}
function Ss(e, t, n) {
  e.problems || (e.problems = []);
  const i = {};
  for (let r = 0; r < e.map.length; r++) {
    const s = e.map[r];
    if (i[s]) continue;
    i[s] = !0;
    const a = n.nodeAt(s);
    if (!a) throw new RangeError(`No cell with offset ${s} found`);
    let c = null;
    const u = a.attrs;
    for (let d = 0; d < u.colspan; d++) {
      const p = t[(r + d) % e.width * 2];
      p != null && (!u.colwidth || u.colwidth[d] != p) && ((c || (c = ks(u)))[d] = p);
    }
    c && e.problems.unshift({
      type: "colwidth mismatch",
      pos: s,
      colwidth: c
    });
  }
}
function ks(e) {
  if (e.colwidth) return e.colwidth.slice();
  const t = [];
  for (let n = 0; n < e.colspan; n++) t.push(0);
  return t;
}
function xe(e) {
  let t = e.cached.tableNodeTypes;
  if (!t) {
    t = e.cached.tableNodeTypes = {};
    for (const n in e.nodes) {
      const i = e.nodes[n], r = i.spec.tableRole;
      r && (t[r] = i);
    }
  }
  return t;
}
new xt("selectingCells");
function Cs(e) {
  for (let t = e.depth - 1; t > 0; t--) if (e.node(t).type.spec.tableRole == "row") return e.node(0).resolve(e.before(t + 1));
  return null;
}
function Hn(e) {
  const t = e.selection.$head;
  for (let n = t.depth; n > 0; n--) if (t.node(n).type.spec.tableRole == "row") return !0;
  return !1;
}
function Ns(e) {
  const t = e.selection;
  if ("$anchorCell" in t && t.$anchorCell) return t.$anchorCell.pos > t.$headCell.pos ? t.$anchorCell : t.$headCell;
  if ("node" in t && t.node && t.node.type.spec.tableRole == "cell") return t.$anchor;
  const n = Cs(t.$head) || Os(t.$head);
  if (n) return n;
  throw new RangeError(`No cell found around position ${t.head}`);
}
function Os(e) {
  for (let t = e.nodeAfter, n = e.pos; t; t = t.firstChild, n++) {
    const i = t.type.spec.tableRole;
    if (i == "cell" || i == "header_cell") return e.doc.resolve(n);
  }
  for (let t = e.nodeBefore, n = e.pos; t; t = t.lastChild, n--) {
    const i = t.type.spec.tableRole;
    if (i == "cell" || i == "header_cell") return e.doc.resolve(n - t.nodeSize);
  }
}
function Je(e) {
  return e.parent.type.spec.tableRole == "row" && !!e.nodeAfter;
}
function Un(e, t) {
  return e.depth == t.depth && e.pos >= t.start(-1) && e.pos <= t.end(-1);
}
function Bn(e, t, n) {
  const i = e.node(-1), r = et.get(i), s = e.start(-1), a = r.nextCell(e.pos - s, t, n);
  return a == null ? null : e.node(0).resolve(s + a);
}
function Fe(e, t, n = 1) {
  const i = {
    ...e,
    colspan: e.colspan - n
  };
  return i.colwidth && (i.colwidth = i.colwidth.slice(), i.colwidth.splice(t, n), i.colwidth.some((r) => r > 0) || (i.colwidth = null)), i;
}
var Y = class tt extends M {
  constructor(t, n = t) {
    const i = t.node(-1), r = et.get(i), s = t.start(-1), a = r.rectBetween(t.pos - s, n.pos - s), c = t.node(0), u = r.cellsInRect(a).filter((p) => p != n.pos - s);
    u.unshift(n.pos - s);
    const d = u.map((p) => {
      const m = i.nodeAt(p);
      if (!m) throw new RangeError(`No cell with offset ${p} found`);
      const w = s + p + 1;
      return new Rn(c.resolve(w), c.resolve(w + m.content.size));
    });
    super(d[0].$from, d[0].$to, d), this.$anchorCell = t, this.$headCell = n;
  }
  map(t, n) {
    const i = t.resolve(n.map(this.$anchorCell.pos)), r = t.resolve(n.map(this.$headCell.pos));
    if (Je(i) && Je(r) && Un(i, r)) {
      const s = this.$anchorCell.node(-1) != i.node(-1);
      return s && this.isRowSelection() ? tt.rowSelection(i, r) : s && this.isColSelection() ? tt.colSelection(i, r) : new tt(i, r);
    }
    return q.between(i, r);
  }
  content() {
    const t = this.$anchorCell.node(-1), n = et.get(t), i = this.$anchorCell.start(-1), r = n.rectBetween(this.$anchorCell.pos - i, this.$headCell.pos - i), s = {}, a = [];
    for (let u = r.top; u < r.bottom; u++) {
      const d = [];
      for (let p = u * n.width + r.left, m = r.left; m < r.right; m++, p++) {
        const w = n.map[p];
        if (s[w]) continue;
        s[w] = !0;
        const y = n.findCell(w);
        let b = t.nodeAt(w);
        if (!b) throw new RangeError(`No cell with offset ${w} found`);
        const E = r.left - y.left, S = y.right - r.right;
        if (E > 0 || S > 0) {
          let T = b.attrs;
          if (E > 0 && (T = Fe(T, 0, E)), S > 0 && (T = Fe(T, T.colspan - S, S)), y.left < r.left) {
            if (b = b.type.createAndFill(T), !b) throw new RangeError(`Could not create cell with attrs ${JSON.stringify(T)}`);
          } else b = b.type.create(T, b.content);
        }
        if (y.top < r.top || y.bottom > r.bottom) {
          const T = {
            ...b.attrs,
            rowspan: Math.min(y.bottom, r.bottom) - Math.max(y.top, r.top)
          };
          y.top < r.top ? b = b.type.createAndFill(T) : b = b.type.create(T, b.content);
        }
        d.push(b);
      }
      a.push(t.child(u).copy(I.from(d)));
    }
    const c = this.isColSelection() && this.isRowSelection() ? t : a;
    return new C(I.from(c), 1, 1);
  }
  replace(t, n = C.empty) {
    const i = t.steps.length, r = this.ranges;
    for (let a = 0; a < r.length; a++) {
      const { $from: c, $to: u } = r[a], d = t.mapping.slice(i);
      t.replace(d.map(c.pos), d.map(u.pos), a ? C.empty : n);
    }
    const s = M.findFrom(t.doc.resolve(t.mapping.slice(i).map(this.to)), -1);
    s && t.setSelection(s);
  }
  replaceWith(t, n) {
    this.replace(t, new C(I.from(n), 0, 0));
  }
  forEachCell(t) {
    const n = this.$anchorCell.node(-1), i = et.get(n), r = this.$anchorCell.start(-1), s = i.cellsInRect(i.rectBetween(this.$anchorCell.pos - r, this.$headCell.pos - r));
    for (let a = 0; a < s.length; a++) t(n.nodeAt(s[a]), r + s[a]);
  }
  isColSelection() {
    const t = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(t, n) > 0) return !1;
    const i = t + this.$anchorCell.nodeAfter.attrs.rowspan, r = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(i, r) == this.$headCell.node(-1).childCount;
  }
  static colSelection(t, n = t) {
    const i = t.node(-1), r = et.get(i), s = t.start(-1), a = r.findCell(t.pos - s), c = r.findCell(n.pos - s), u = t.node(0);
    return a.top <= c.top ? (a.top > 0 && (t = u.resolve(s + r.map[a.left])), c.bottom < r.height && (n = u.resolve(s + r.map[r.width * (r.height - 1) + c.right - 1]))) : (c.top > 0 && (n = u.resolve(s + r.map[c.left])), a.bottom < r.height && (t = u.resolve(s + r.map[r.width * (r.height - 1) + a.right - 1]))), new tt(t, n);
  }
  isRowSelection() {
    const t = this.$anchorCell.node(-1), n = et.get(t), i = this.$anchorCell.start(-1), r = n.colCount(this.$anchorCell.pos - i), s = n.colCount(this.$headCell.pos - i);
    if (Math.min(r, s) > 0) return !1;
    const a = r + this.$anchorCell.nodeAfter.attrs.colspan, c = s + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(a, c) == n.width;
  }
  eq(t) {
    return t instanceof tt && t.$anchorCell.pos == this.$anchorCell.pos && t.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(t, n = t) {
    const i = t.node(-1), r = et.get(i), s = t.start(-1), a = r.findCell(t.pos - s), c = r.findCell(n.pos - s), u = t.node(0);
    return a.left <= c.left ? (a.left > 0 && (t = u.resolve(s + r.map[a.top * r.width])), c.right < r.width && (n = u.resolve(s + r.map[r.width * (c.top + 1) - 1]))) : (c.left > 0 && (n = u.resolve(s + r.map[c.top * r.width])), a.right < r.width && (t = u.resolve(s + r.map[r.width * (a.top + 1) - 1]))), new tt(t, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(t, n) {
    return new tt(t.resolve(n.anchor), t.resolve(n.head));
  }
  static create(t, n, i = n) {
    return new tt(t.resolve(n), t.resolve(i));
  }
  getBookmark() {
    return new Is(this.$anchorCell.pos, this.$headCell.pos);
  }
};
Y.prototype.visible = !1;
M.jsonID("cell", Y);
var Is = class _n {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new _n(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    const n = t.resolve(this.anchor), i = t.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && i.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && i.index() < i.parent.childCount && Un(n, i) ? new Y(n, i) : M.near(i, 1);
  }
};
new xt("fix-tables");
function Jn(e) {
  const t = e.selection, n = Ns(e), i = n.node(-1), r = n.start(-1), s = et.get(i);
  return {
    ...t instanceof Y ? s.rectBetween(t.$anchorCell.pos - r, t.$headCell.pos - r) : s.findCell(n.pos - r),
    tableStart: r,
    map: s,
    table: i
  };
}
function Ms(e) {
  return function(t, n) {
    if (!Hn(t)) return !1;
    if (n) {
      const i = xe(t.schema), r = Jn(t), s = t.tr, a = r.map.cellsInRect(e == "column" ? {
        left: r.left,
        top: 0,
        right: r.right,
        bottom: r.map.height
      } : e == "row" ? {
        left: 0,
        top: r.top,
        right: r.map.width,
        bottom: r.bottom
      } : r), c = a.map((u) => r.table.nodeAt(u));
      for (let u = 0; u < a.length; u++) c[u].type == i.header_cell && s.setNodeMarkup(r.tableStart + a[u], i.cell, c[u].attrs);
      if (s.steps.length === 0) for (let u = 0; u < a.length; u++) s.setNodeMarkup(r.tableStart + a[u], i.header_cell, c[u].attrs);
      n(s);
    }
    return !0;
  };
}
function Xe(e, t, n) {
  const i = t.map.cellsInRect({
    left: 0,
    top: 0,
    right: e == "row" ? t.map.width : 1,
    bottom: e == "column" ? t.map.height : 1
  });
  for (let r = 0; r < i.length; r++) {
    const s = t.table.nodeAt(i[r]);
    if (s && s.type !== n.header_cell) return !1;
  }
  return !0;
}
function Ee(e, t) {
  return t = t || { useDeprecatedLogic: !1 }, t.useDeprecatedLogic ? Ms(e) : function(n, i) {
    if (!Hn(n)) return !1;
    if (i) {
      const r = xe(n.schema), s = Jn(n), a = n.tr, c = Xe("row", s, r), u = Xe("column", s, r), d = (e === "column" ? c : e === "row" && u) ? 1 : 0, p = e == "column" ? {
        left: 0,
        top: d,
        right: 1,
        bottom: s.map.height
      } : e == "row" ? {
        left: d,
        top: 0,
        right: s.map.width,
        bottom: 1
      } : s, m = e == "column" ? u ? r.cell : r.header_cell : e == "row" ? c ? r.cell : r.header_cell : r.cell;
      s.map.cellsInRect(p).forEach((w) => {
        const y = w + s.tableStart, b = a.doc.nodeAt(y);
        b && a.setNodeMarkup(y, m, b.attrs);
      }), i(a);
    }
    return !0;
  };
}
Ee("row", { useDeprecatedLogic: !0 });
Ee("column", { useDeprecatedLogic: !0 });
Ee("cell", { useDeprecatedLogic: !0 });
function Ht(e, t) {
  const n = e.selection;
  if (!(n instanceof Y)) return !1;
  if (t) {
    const i = e.tr, r = xe(e.schema).cell.createAndFill().content;
    n.forEachCell((s, a) => {
      s.content.eq(r) || i.replace(i.mapping.map(a + 1), i.mapping.map(a + s.nodeSize - 1), new C(r, 0, 0));
    }), i.docChanged && t(i);
  }
  return !0;
}
xs({
  ArrowLeft: Ut("horiz", -1),
  ArrowRight: Ut("horiz", 1),
  ArrowUp: Ut("vert", -1),
  ArrowDown: Ut("vert", 1),
  "Shift-ArrowLeft": Bt("horiz", -1),
  "Shift-ArrowRight": Bt("horiz", 1),
  "Shift-ArrowUp": Bt("vert", -1),
  "Shift-ArrowDown": Bt("vert", 1),
  Backspace: Ht,
  "Mod-Backspace": Ht,
  Delete: Ht,
  "Mod-Delete": Ht
});
function Jt(e, t, n) {
  return n.eq(e.selection) ? !1 : (t && t(e.tr.setSelection(n).scrollIntoView()), !0);
}
function Ut(e, t) {
  return (n, i, r) => {
    if (!r) return !1;
    const s = n.selection;
    if (s instanceof Y) return Jt(n, i, M.near(s.$headCell, t));
    if (e != "horiz" && !s.empty) return !1;
    const a = Fn(r, e, t);
    if (a == null) return !1;
    if (e == "horiz") return Jt(n, i, M.near(n.doc.resolve(s.head + t), t));
    {
      const c = n.doc.resolve(a), u = Bn(c, e, t);
      let d;
      return u ? d = M.near(u, 1) : t < 0 ? d = M.near(n.doc.resolve(c.before(-1)), -1) : d = M.near(n.doc.resolve(c.after(-1)), 1), Jt(n, i, d);
    }
  };
}
function Bt(e, t) {
  return (n, i, r) => {
    if (!r) return !1;
    const s = n.selection;
    let a;
    if (s instanceof Y) a = s;
    else {
      const u = Fn(r, e, t);
      if (u == null) return !1;
      a = new Y(n.doc.resolve(u));
    }
    const c = Bn(a.$headCell, e, t);
    return c ? Jt(n, i, new Y(a.$anchorCell, c)) : !1;
  };
}
function Fn(e, t, n) {
  if (!(e.state.selection instanceof q)) return null;
  const { $head: i } = e.state.selection;
  for (let r = i.depth - 1; r >= 0; r--) {
    const s = i.node(r);
    if ((n < 0 ? i.index(r) : i.indexAfter(r)) != (n < 0 ? 0 : s.childCount)) return null;
    if (s.type.spec.tableRole == "cell" || s.type.spec.tableRole == "header_cell") {
      const a = i.before(r), c = t == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return e.endOfTextblock(c) ? a : null;
    }
  }
  return null;
}
new xt("tableColumnResizing");
function Ls(e, t) {
  const n = Math.min(e.top, t.top), i = Math.max(e.bottom, t.bottom), r = Math.min(e.left, t.left), a = Math.max(e.right, t.right) - r, c = i - n, u = r, d = n;
  return new DOMRect(u, d, a, c);
}
var $s = class {
  constructor({
    editor: e,
    element: t,
    view: n,
    pluginKey: i = "bubbleMenu",
    updateDelay: r = 250,
    resizeDelay: s = 60,
    shouldShow: a,
    appendTo: c,
    getReferencedVirtualElement: u,
    options: d
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    }, this.shouldShow = ({ view: m, state: w, from: y, to: b }) => {
      const { doc: E, selection: S } = w, { empty: T } = S, P = !E.textBetween(y, b).length && xr(w.selection), R = this.element.contains(document.activeElement);
      return !(!(m.hasFocus() || R) || T || P || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: m }) => {
      var w;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      m?.relatedTarget && ((w = this.element.parentNode) != null && w.contains(m.relatedTarget)) || m?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.handleDebouncedUpdate = (m, w) => {
      const y = !w?.selection.eq(m.state.selection), b = !w?.doc.eq(m.state.doc);
      !y && !b || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(m, y, b, w);
      }, this.updateDelay));
    }, this.updateHandler = (m, w, y, b) => {
      const { composing: E } = m;
      if (E || !w && !y)
        return;
      if (!this.getShouldShow(b)) {
        this.hide();
        return;
      }
      this.show(), this.updatePosition();
    }, this.transactionHandler = ({ transaction: m }) => {
      const w = m.getMeta(this.pluginKey);
      w === "updatePosition" ? this.updatePosition() : w && typeof w == "object" && w.type === "updateOptions" ? this.updateOptions(w.options) : w === "hide" ? this.hide() : w === "show" && (this.updatePosition(), this.show());
    };
    var p;
    this.editor = e, this.element = t, this.view = n, this.pluginKey = i, this.updateDelay = r, this.resizeDelay = s, this.appendTo = c, this.scrollTarget = (p = d?.scrollTarget) != null ? p : window, this.getReferencedVirtualElement = u, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...d
    }, this.element.tabIndex = 0, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(n, n.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const e = [];
    return this.floatingUIOptions.flip && e.push(nn(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && e.push(
      rn(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && e.push(
      sn(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && e.push(on(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && e.push(ln(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && e.push(
      an(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && e.push(cn(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && e.push(
      un(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), e;
  }
  get virtualElement() {
    var e, t, n;
    const { selection: i } = this.editor.state, r = (e = this.getReferencedVirtualElement) == null ? void 0 : e.call(this);
    if (r)
      return r;
    if (!((n = (t = this.view) == null ? void 0 : t.dom) != null && n.parentNode))
      return;
    const s = en(this.view, i.from, i.to);
    let a = {
      getBoundingClientRect: () => s,
      getClientRects: () => [s]
    };
    if (i instanceof V) {
      let c = this.view.nodeDOM(i.from);
      const u = c.dataset.nodeViewWrapper ? c : c.querySelector("[data-node-view-wrapper]");
      u && (c = u), c && (a = {
        getBoundingClientRect: () => c.getBoundingClientRect(),
        getClientRects: () => [c.getBoundingClientRect()]
      });
    }
    if (i instanceof Y) {
      const { $anchorCell: c, $headCell: u } = i, d = c ? c.pos : u.pos, p = u ? u.pos : c.pos, m = this.view.nodeDOM(d), w = this.view.nodeDOM(p);
      if (!m || !w)
        return;
      const y = m === w ? m.getBoundingClientRect() : Ls(
        m.getBoundingClientRect(),
        w.getBoundingClientRect()
      );
      a = {
        getBoundingClientRect: () => y,
        getClientRects: () => [y]
      };
    }
    return a;
  }
  updatePosition() {
    if (!this.isVisible)
      return;
    const e = this.virtualElement;
    e && hn(e, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: t, y: n, strategy: i, middlewareData: r }) => {
      var s, a;
      if (!(!this.isVisible || this.editor.isDestroyed || !this.element.isConnected)) {
        if ((s = r.hide) != null && s.referenceHidden || (a = r.hide) != null && a.escaped) {
          this.element.style.visibility = "hidden";
          return;
        }
        this.element.style.visibility = "visible", this.element.style.width = "max-content", this.element.style.position = i, this.element.style.left = `${t}px`, this.element.style.top = `${n}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
      }
    });
  }
  update(e, t) {
    const { state: n } = e, i = n.selection.from !== n.selection.to;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const r = !t?.selection.eq(e.state.selection), s = !t?.doc.eq(e.state.doc);
    this.updateHandler(e, r, s, t);
  }
  getShouldShow(e) {
    var t;
    const { state: n } = this.view, { selection: i } = n, { ranges: r } = i, s = Math.min(...r.map((u) => u.$from.pos)), a = Math.max(...r.map((u) => u.$to.pos));
    return ((t = this.shouldShow) == null ? void 0 : t.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: n,
      oldState: e,
      from: s,
      to: a
    })) || !1;
  }
  show() {
    var e;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const t = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (e = t ?? this.view.dom.parentElement) == null || e.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  updateOptions(e) {
    var t;
    if (e.updateDelay !== void 0 && (this.updateDelay = e.updateDelay), e.resizeDelay !== void 0 && (this.resizeDelay = e.resizeDelay), e.appendTo !== void 0 && (this.appendTo = e.appendTo), e.getReferencedVirtualElement !== void 0 && (this.getReferencedVirtualElement = e.getReferencedVirtualElement), e.shouldShow !== void 0 && e.shouldShow && (this.shouldShow = e.shouldShow), e.options !== void 0) {
      const n = (t = e.options.scrollTarget) != null ? t : window;
      n !== this.scrollTarget && (this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.scrollTarget = n, this.scrollTarget.addEventListener("scroll", this.resizeHandler)), this.floatingUIOptions = {
        ...this.floatingUIOptions,
        ...e.options
      };
    }
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, Xn = (e) => new zn({
  key: typeof e.pluginKey == "string" ? new xt(e.pluginKey) : e.pluginKey,
  view: (t) => new $s({ view: t, ...e })
});
G.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      appendTo: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Xn({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        updateDelay: this.options.updateDelay,
        options: this.options.options,
        appendTo: this.options.appendTo,
        getReferencedVirtualElement: this.options.getReferencedVirtualElement,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
var As = class {
  constructor({
    editor: e,
    element: t,
    view: n,
    pluginKey: i = "floatingMenu",
    updateDelay: r = 250,
    resizeDelay: s = 60,
    options: a,
    appendTo: c,
    shouldShow: u
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.shouldShow = ({ view: p, state: m }) => {
      const { selection: w } = m, { $anchor: y, empty: b } = w, E = y.depth === 1, S = y.parent.isTextblock && !y.parent.type.spec.code && !y.parent.textContent && y.parent.childCount === 0 && !this.getTextContent(y.parent);
      return !(!p.hasFocus() || !b || !E || !S || !this.editor.isEditable);
    }, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "right",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1
    }, this.updateHandler = (p, m, w, y) => {
      const { composing: b } = p;
      if (b || !m && !w)
        return;
      if (!this.getShouldShow(y)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: p }) => {
      var m;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      p?.relatedTarget && ((m = this.element.parentNode) != null && m.contains(p.relatedTarget)) || p?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.transactionHandler = ({ transaction: p }) => {
      const m = p.getMeta(this.pluginKey);
      m === "updatePosition" ? this.updatePosition() : m && typeof m == "object" && m.type === "updateOptions" ? this.updateOptions(m.options) : m === "hide" ? this.hide() : m === "show" && (this.updatePosition(), this.show());
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    };
    var d;
    this.editor = e, this.element = t, this.view = n, this.pluginKey = i, this.updateDelay = r, this.resizeDelay = s, this.appendTo = c, this.scrollTarget = (d = a?.scrollTarget) != null ? d : window, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...a
    }, this.element.tabIndex = 0, u && (this.shouldShow = u), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(n, n.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  getTextContent(e) {
    return Er(e, { textSerializers: Tr(this.editor.schema) });
  }
  get middlewares() {
    const e = [];
    return this.floatingUIOptions.flip && e.push(nn(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && e.push(
      rn(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && e.push(
      sn(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && e.push(on(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && e.push(ln(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && e.push(
      an(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && e.push(cn(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && e.push(
      un(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), e;
  }
  getShouldShow(e) {
    var t;
    const { state: n } = this.view, { selection: i } = n, { ranges: r } = i, s = Math.min(...r.map((u) => u.$from.pos)), a = Math.max(...r.map((u) => u.$to.pos));
    return (t = this.shouldShow) == null ? void 0 : t.call(this, {
      editor: this.editor,
      view: this.view,
      state: n,
      oldState: e,
      from: s,
      to: a
    });
  }
  updateOptions(e) {
    var t;
    if (e.updateDelay !== void 0 && (this.updateDelay = e.updateDelay), e.resizeDelay !== void 0 && (this.resizeDelay = e.resizeDelay), e.appendTo !== void 0 && (this.appendTo = e.appendTo), e.shouldShow !== void 0 && e.shouldShow && (this.shouldShow = e.shouldShow), e.options !== void 0) {
      const n = (t = e.options.scrollTarget) != null ? t : window;
      n !== this.scrollTarget && (this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.scrollTarget = n, this.scrollTarget.addEventListener("scroll", this.resizeHandler)), this.floatingUIOptions = {
        ...this.floatingUIOptions,
        ...e.options
      };
    }
  }
  updatePosition() {
    const { selection: e } = this.editor.state, t = en(this.view, e.from, e.to);
    hn({
      getBoundingClientRect: () => t,
      getClientRects: () => [t]
    }, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: i, y: r, strategy: s, middlewareData: a }) => {
      var c, u;
      if ((c = a.hide) != null && c.referenceHidden || (u = a.hide) != null && u.escaped) {
        this.element.style.visibility = "hidden";
        return;
      }
      this.element.style.visibility = "visible", this.element.style.width = "max-content", this.element.style.position = s, this.element.style.left = `${i}px`, this.element.style.top = `${r}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(e, t) {
    const n = !t?.selection.eq(e.state.selection), i = !t?.doc.eq(e.state.doc);
    this.updateHandler(e, n, i, t);
  }
  show() {
    var e;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const t = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (e = t ?? this.view.dom.parentElement) == null || e.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, Kn = (e) => new zn({
  key: typeof e.pluginKey == "string" ? new xt(e.pluginKey) : e.pluginKey,
  view: (t) => new As({ view: t, ...e })
});
G.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      options: {},
      pluginKey: "floatingMenu",
      updateDelay: void 0,
      resizeDelay: void 0,
      appendTo: void 0,
      shouldShow: null
    };
  },
  addCommands() {
    return {
      updateFloatingMenuPosition: () => ({ tr: e, dispatch: t }) => (t && e.setMeta(this.options.pluginKey, "updatePosition"), !0)
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Kn({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        updateDelay: this.options.updateDelay,
        resizeDelay: this.options.resizeDelay,
        options: this.options.options,
        appendTo: this.options.appendTo,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
function jn(e, t) {
  return e ?? new xt(t);
}
var Rs = typeof window < "u" ? gr : j, qn = /* @__PURE__ */ new Set(["left", "opacity", "position", "top", "visibility", "width"]), Ds = /* @__PURE__ */ new Set([
  "animationIterationCount",
  "aspectRatio",
  "borderImageOutset",
  "borderImageSlice",
  "borderImageWidth",
  "columnCount",
  "columns",
  "fillOpacity",
  "flex",
  "flexGrow",
  "flexShrink",
  "fontWeight",
  "gridArea",
  "gridColumn",
  "gridColumnEnd",
  "gridColumnStart",
  "gridRow",
  "gridRowEnd",
  "gridRowStart",
  "lineClamp",
  "lineHeight",
  "opacity",
  "order",
  "orphans",
  "scale",
  "stopOpacity",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "tabSize",
  "widows",
  "zIndex",
  "zoom"
]), zs = /* @__PURE__ */ new Set(["children", "className", "style"]), Ps = /* @__PURE__ */ new Set(["tabIndex"]), Hs = /* @__PURE__ */ new Set([
  "accessKey",
  "autoCapitalize",
  "contentEditable",
  "contextMenu",
  "dir",
  "draggable",
  "enterKeyHint",
  "hidden",
  "id",
  "lang",
  "nonce",
  "role",
  "slot",
  "spellCheck",
  "tabIndex",
  "title",
  "translate"
]), Us = {
  Blur: "focusout",
  DoubleClick: "dblclick",
  Focus: "focusin",
  MouseEnter: "mouseenter",
  MouseLeave: "mouseleave"
};
function fe(e, t) {
  return /^on[A-Z]/.test(e) && typeof t == "function";
}
function Bs(e) {
  return e.startsWith("aria-") || e.startsWith("data-"), e;
}
function _s(e) {
  return e.startsWith("aria-") || e.startsWith("data-") || Hs.has(e);
}
function Vn(e) {
  return e.startsWith("--") ? e : e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
function Js(e) {
  var t;
  const n = e.endsWith("Capture"), r = (n ? e.slice(0, -7) : e).slice(2);
  return {
    eventName: (t = Us[r]) != null ? t : r.toLowerCase(),
    options: n ? { capture: !0 } : void 0
  };
}
function Fs(e, t) {
  let n = t.defaultPrevented, i = !1;
  const r = Object.create(t);
  return Object.defineProperties(r, {
    nativeEvent: { value: t },
    currentTarget: { value: e },
    target: { value: t.target },
    persist: { value: () => {
    } },
    isDefaultPrevented: { value: () => n },
    isPropagationStopped: { value: () => i },
    preventDefault: {
      value: () => {
        n = !0, t.preventDefault();
      }
    },
    stopPropagation: {
      value: () => {
        i = !0, t.stopPropagation();
      }
    }
  }), r;
}
function se(e) {
  return Ps.has(e);
}
function Ke(e, t, n) {
  if (t === "tabIndex") {
    e.tabIndex = Number(n);
    return;
  }
  e[t] = n;
}
function Xs(e, t) {
  if (t === "tabIndex") {
    e.removeAttribute("tabindex");
    return;
  }
  const n = e[t];
  if (typeof n == "boolean") {
    e[t] = !1;
    return;
  }
  if (typeof n == "number") {
    e[t] = 0;
    return;
  }
  e[t] = "";
}
function Ks(e, t) {
  return typeof t != "number" || t === 0 || e.startsWith("--") || Ds.has(e) ? String(t) : `${t}px`;
}
function js(e, t) {
  qn.has(t) || e.style.removeProperty(Vn(t));
}
function qs(e, t, n) {
  qn.has(t) || e.style.setProperty(Vn(t), Ks(t, n));
}
function Vs(e, t, n) {
  (/* @__PURE__ */ new Set([...Object.keys(t), ...Object.keys(n)])).forEach((r) => {
    if (zs.has(r) || !_s(r) || fe(r, t[r]) || fe(r, n[r]))
      return;
    const s = t[r], a = n[r];
    if (s === a)
      return;
    const c = Bs(r);
    if (a == null || a === !1) {
      se(r) && Xs(e, r), e.removeAttribute(c);
      return;
    }
    if (a === !0) {
      se(r) && Ke(e, r, !0), e.setAttribute(c, "");
      return;
    }
    if (se(r)) {
      Ke(e, r, a);
      return;
    }
    e.setAttribute(c, String(a));
  });
}
function Ws(e, t, n) {
  if (t !== n) {
    if (n) {
      e.className = n;
      return;
    }
    e.removeAttribute("class");
  }
}
function Ys(e, t, n) {
  const i = t ?? {}, r = n ?? {};
  (/* @__PURE__ */ new Set([...Object.keys(i), ...Object.keys(r)])).forEach((a) => {
    const c = i[a], u = r[a];
    if (c !== u) {
      if (u == null) {
        js(e, a);
        return;
      }
      qs(e, a, u);
    }
  });
}
function Gs(e, t, n) {
  t.forEach(({ eventName: r, listener: s, options: a }) => {
    e.removeEventListener(r, s, a);
  });
  const i = [];
  return Object.entries(n).forEach(([r, s]) => {
    if (!fe(r, s))
      return;
    const { eventName: a, options: c } = Js(r), u = (d) => {
      s(Fs(e, d));
    };
    e.addEventListener(a, u, c), i.push({ eventName: a, listener: u, options: c });
  }), i;
}
function Wn(e, t) {
  const n = K({}), i = K([]);
  Rs(() => {
    const r = n.current;
    return Ws(e, r.className, t.className), Ys(e, r.style, t.style), Vs(e, r, t), i.current = Gs(e, i.current, t), n.current = t, () => {
      i.current.forEach(({ eventName: s, listener: a, options: c }) => {
        e.removeEventListener(s, a, c);
      }), i.current = [];
    };
  }, [e, t]);
}
var Zs = Mt.forwardRef(
  ({
    pluginKey: e,
    editor: t,
    updateDelay: n,
    resizeDelay: i,
    appendTo: r,
    shouldShow: s = null,
    getReferencedVirtualElement: a,
    options: c,
    children: u,
    ...d
  }, p) => {
    const m = K(document.createElement("div")), w = K(jn(e, "bubbleMenu")).current;
    Wn(m.current, d), typeof p == "function" ? p(m.current) : p && (p.current = m.current);
    const { editor: y } = tn(), b = t || y, E = {
      updateDelay: n,
      resizeDelay: i,
      appendTo: r,
      pluginKey: w,
      shouldShow: s,
      getReferencedVirtualElement: a,
      options: c
    }, S = K(E);
    S.current = E;
    const [T, P] = we(!1), R = K(!0);
    return j(() => {
      if (b?.isDestroyed)
        return;
      if (!b) {
        console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
        return;
      }
      const z = m.current;
      z.style.visibility = "hidden", z.style.position = "absolute";
      const k = Xn({
        ...S.current,
        editor: b,
        element: z
      });
      b.registerPlugin(k);
      const x = S.current.pluginKey;
      return R.current = !0, P(!0), () => {
        P(!1), b.unregisterPlugin(x), window.requestAnimationFrame(() => {
          z.parentNode && z.parentNode.removeChild(z);
        });
      };
    }, [b]), j(() => {
      if (!(!T || !b || b.isDestroyed)) {
        if (R.current) {
          R.current = !1;
          return;
        }
        b.view.dispatch(
          b.state.tr.setMeta(w, {
            type: "updateOptions",
            options: S.current
          })
        );
      }
    }, [
      T,
      b,
      n,
      i,
      s,
      c,
      r,
      a,
      w
    ]), dn(u, m.current);
  }
), Qs = Mt.forwardRef(
  ({ pluginKey: e, editor: t, updateDelay: n, resizeDelay: i, appendTo: r, shouldShow: s = null, options: a, children: c, ...u }, d) => {
    const p = K(document.createElement("div")), m = K(jn(e, "floatingMenu")).current;
    Wn(p.current, u), typeof d == "function" ? d(p.current) : d && (d.current = p.current);
    const { editor: w } = tn(), y = t || w, b = {
      updateDelay: n,
      resizeDelay: i,
      appendTo: r,
      pluginKey: m,
      shouldShow: s,
      options: a
    }, E = K(b);
    E.current = b;
    const [S, T] = we(!1), P = K(!0);
    return j(() => {
      if (y?.isDestroyed)
        return;
      if (!y) {
        console.warn(
          "FloatingMenu component is not rendered inside of an editor component or does not have editor prop."
        );
        return;
      }
      const R = p.current;
      R.style.visibility = "hidden", R.style.position = "absolute";
      const z = Kn({
        ...E.current,
        editor: y,
        element: R
      });
      y.registerPlugin(z);
      const k = E.current.pluginKey;
      return P.current = !0, T(!0), () => {
        T(!1), y.unregisterPlugin(k), window.requestAnimationFrame(() => {
          R.parentNode && R.parentNode.removeChild(R);
        });
      };
    }, [y]), j(() => {
      if (!(!S || !y || y.isDestroyed)) {
        if (P.current) {
          P.current = !1;
          return;
        }
        y.view.dispatch(
          y.state.tr.setMeta(m, {
            type: "updateOptions",
            options: E.current
          })
        );
      }
    }, [S, y, n, i, s, a, r, m]), dn(c, p.current);
  }
);
const to = ({ editor: e }) => {
  if (!e)
    return null;
  const [t] = Mt.useState(!0), [n] = Mt.useState(!0);
  j(() => {
    e && e.setEditable(n);
  }, [n, e]);
  const i = yr({
    editor: e,
    selector: (r) => ({
      isTerm: r.editor.isActive("term"),
      canTerm: r.editor.can().chain().focus().toggleMark("term").run(),
      isEm: r.editor.isActive("em"),
      canEm: r.editor.can().chain().focus().toggleMark("em").run(),
      isAlert: r.editor.isActive("alert"),
      canAlert: r.editor.can().chain().focus().toggleMark("alert").run()
    })
  });
  return /* @__PURE__ */ N(Ge, { children: e && t && /* @__PURE__ */ N(
    Zs,
    {
      shouldShow: null,
      editor: e,
      options: { placement: "bottom", autoPlacement: !0, offset: 8 },
      children: /* @__PURE__ */ F("div", { className: "button-group", children: [
        /* @__PURE__ */ N(
          "button",
          {
            onClick: () => e.chain().focus().toggleMark("em").run(),
            disabled: !i.canEm,
            className: i.isEm ? "is-active" : "",
            children: "<em>"
          }
        ),
        /* @__PURE__ */ N(
          "button",
          {
            onClick: () => e.chain().focus().toggleMark("term").run(),
            disabled: !i.canTerm,
            className: i.isTerm ? "is-active" : "",
            children: "<term>"
          }
        ),
        /* @__PURE__ */ N(
          "button",
          {
            onClick: () => e.chain().focus().toggleMark("alert").run(),
            disabled: !i.canAlert,
            className: i.isAlert ? "is-active" : "",
            children: "<alert>"
          }
        )
      ] })
    }
  ) });
};
var oe, je;
function eo() {
  if (je) return oe;
  je = 1;
  var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, i = Object.prototype.hasOwnProperty, r = (l, o) => {
    for (var h in o)
      e(l, h, { get: o[h], enumerable: !0 });
  }, s = (l, o, h, f) => {
    if (o && typeof o == "object" || typeof o == "function")
      for (let g of n(o))
        !i.call(l, g) && g !== h && e(l, g, { get: () => o[g], enumerable: !(f = t(o, g)) || f.enumerable });
    return l;
  }, a = (l) => s(e({}, "__esModule", { value: !0 }), l), c = {};
  r(c, {
    XmlCdata: () => Z,
    XmlComment: () => Et,
    XmlDeclaration: () => Tt,
    XmlDocument: () => St,
    XmlDocumentType: () => kt,
    XmlElement: () => at,
    XmlError: () => Ct,
    XmlNode: () => x,
    XmlProcessingInstruction: () => ct,
    XmlText: () => J,
    parseXml: () => Gt
  }), oe = a(c);
  var u = "", d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, p = class {
    constructor(l) {
      if (this.k = this.u(l, !0), this.d = 0, this.length = l.length, this.l = this.k !== this.length, this.h = l, this.l) {
        let o = [];
        for (let h = 0, f = 0; f < this.k; ++f)
          o[f] = h, h += l.codePointAt(h) > 65535 ? 2 : 1;
        this.A = o;
      }
    }
    /**
     * Whether the current character index is at the end of the input string.
     */
    get B() {
      return this.d >= this.k;
    }
    // -- Protected Methods ------------------------------------------------------
    /**
     * Returns the number of characters in the given string, which may differ from
     * the byte length if the string contains multibyte characters.
     */
    u(l, o = this.l) {
      return o ? l.replace(d, "_").length : l.length;
    }
    // -- Public Methods ---------------------------------------------------------
    /**
     * Advances the scanner by the given number of characters, stopping if the end
     * of the string is reached.
     */
    p(l = 1) {
      this.d = Math.min(this.k, this.d + l);
    }
    /**
     * Returns the byte index of the given character index in the string. The two
     * may differ in strings that contain multibyte characters.
     */
    f(l = this.d) {
      var o;
      return this.l ? (o = this.A[l]) != null ? o : 1 / 0 : l;
    }
    /**
     * Consumes and returns the given number of characters if possible, advancing
     * the scanner and stopping if the end of the string is reached.
     *
     * If no characters could be consumed, an empty string will be returned.
     */
    G(l = 1) {
      let o = this.m(l);
      return this.p(l), o;
    }
    /**
     * Consumes and returns the given number of bytes if possible, advancing the
     * scanner and stopping if the end of the string is reached.
     *
     * It's up to the caller to ensure that the given byte count doesn't split a
     * multibyte character.
     *
     * If no bytes could be consumed, an empty string will be returned.
     */
    v(l) {
      let o = this.f(), h = this.h.slice(o, o + l);
      return this.p(this.u(h)), h;
    }
    /**
     * Consumes and returns all characters for which the given function returns
     * `true`, stopping when `false` is returned or the end of the input is
     * reached.
     */
    w(l) {
      let { length: o, l: h, h: f } = this, g = this.f(), v = g;
      if (h)
        for (; v < o; ) {
          let O = f[v], $ = O >= "\uD800" && O <= "\uDBFF";
          if ($ && (O += f[v + 1]), !l(O))
            break;
          v += $ ? 2 : 1;
        }
      else
        for (; v < o && l(f[v]); )
          ++v;
      return this.v(v - g);
    }
    /**
     * Consumes the given string if it exists at the current character index, and
     * advances the scanner.
     *
     * If the given string doesn't exist at the current character index, an empty
     * string will be returned and the scanner will not be advanced.
     */
    b(l) {
      let { length: o } = l, h = this.f();
      return l === this.h.slice(h, h + o) ? (this.p(o === 1 ? 1 : this.u(l)), l) : u;
    }
    /**
     * Consumes characters until the given global regex is matched, advancing the
     * scanner up to (but not beyond) the beginning of the match. If the regex
     * doesn't match, nothing will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    x(l) {
      let o = this.h.slice(this.f()).search(l);
      return o > 0 ? this.v(o) : u;
    }
    /**
     * Consumes characters until the given string is found, advancing the scanner
     * up to (but not beyond) that point. If the string is never found, nothing
     * will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    s(l) {
      let o = this.f(), h = this.h.indexOf(l, o);
      return h > 0 ? this.v(h - o) : u;
    }
    /**
     * Returns the given number of characters starting at the current character
     * index, without advancing the scanner and without exceeding the end of the
     * input string.
     */
    m(l = 1) {
      let { d: o, h } = this;
      return this.l ? h.slice(this.f(o), this.f(o + l)) : h.slice(o, o + l);
    }
    /**
     * Resets the scanner position to the given character _index_, or to the start
     * of the input string if no index is given.
     *
     * If _index_ is negative, the scanner position will be moved backward by that
     * many characters, stopping if the beginning of the string is reached.
     */
    n(l = 0) {
      this.d = l >= 0 ? Math.min(this.k, l) : Math.max(0, this.d + l);
    }
  }, m = /["&<]/, w = /['&<]/, y = /\r\n|[\n\r\t]/g, b = /<|&|]]>/, E = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }));
  function S(l) {
    let o = l.codePointAt(0);
    return o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 48 && o <= 57 || o === 45 || o === 46 || o === 183 || o >= 768 && o <= 879 || o === 8255 || o === 8256 || T(l, o);
  }
  function T(l, o = l.codePointAt(0)) {
    return o >= 97 && o <= 122 || o >= 65 && o <= 90 || o === 58 || o === 95 || o >= 192 && o <= 214 || o >= 216 && o <= 246 || o >= 248 && o <= 767 || o >= 880 && o <= 893 || o >= 895 && o <= 8191 || o === 8204 || o === 8205 || o >= 8304 && o <= 8591 || o >= 11264 && o <= 12271 || o >= 12289 && o <= 55295 || o >= 63744 && o <= 64975 || o >= 65008 && o <= 65533 || o >= 65536 && o <= 983039;
  }
  function P(l) {
    return l === "#" || S(l);
  }
  function R(l) {
    let o = l.codePointAt(0);
    return o === 32 || o === 9 || o === 10 || o === 13;
  }
  function z(l) {
    return l >= 32 && l <= 55295 || l === 10 || l === 9 || l === 13 || l >= 57344 && l <= 65533 || l >= 65536 && l <= 1114111;
  }
  var k = class Yn {
    constructor() {
      this.parent = null, this.start = -1, this.end = -1;
    }
    /**
     * Document that contains this node, or `null` if this node is not associated
     * with a document.
     */
    get document() {
      var o, h;
      return (h = (o = this.parent) == null ? void 0 : o.document) != null ? h : null;
    }
    /**
     * Whether this node is the root node of the document (also known as the
     * document element).
     */
    get isRootNode() {
      return this.parent !== null && this.parent === this.document && this.type === Yn.TYPE_ELEMENT;
    }
    /**
     * Whether whitespace should be preserved in the content of this element and
     * its children.
     *
     * This is influenced by the value of the special `xml:space` attribute, and
     * will be `true` for any node whose `xml:space` attribute is set to
     * "preserve". If a node has no such attribute, it will inherit the value of
     * the nearest ancestor that does (if any).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-white-space
     */
    get preserveWhitespace() {
      var o;
      return !!((o = this.parent) != null && o.preserveWhitespace);
    }
    /**
     * Type of this node.
     *
     * The value of this property is a string that matches one of the static
     * `TYPE_*` properties on the `XmlNode` class (e.g. `TYPE_ELEMENT`,
     * `TYPE_TEXT`, etc.).
     *
     * The `XmlNode` class itself is a base class and doesn't have its own type
     * name.
     */
    get type() {
      return "";
    }
    /**
     * Returns a JSON-serializable object representing this node, minus properties
     * that could result in circular references.
     */
    toJSON() {
      let o = {
        type: this.type
      };
      return this.isRootNode && (o.isRootNode = !0), this.preserveWhitespace && (o.preserveWhitespace = !0), this.start !== -1 && (o.start = this.start, o.end = this.end), o;
    }
  };
  k.TYPE_CDATA = "cdata", k.TYPE_COMMENT = "comment", k.TYPE_DOCUMENT = "document", k.TYPE_DOCUMENT_TYPE = "doctype", k.TYPE_ELEMENT = "element", k.TYPE_PROCESSING_INSTRUCTION = "pi", k.TYPE_TEXT = "text", k.TYPE_XML_DECLARATION = "xmldecl";
  var x = k, J = class extends x {
    constructor(l = "") {
      super(), this.text = l;
    }
    get type() {
      return x.TYPE_TEXT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        text: this.text
      });
    }
  }, Z = class extends J {
    get type() {
      return x.TYPE_CDATA;
    }
  }, Et = class extends x {
    constructor(l = "") {
      super(), this.content = l;
    }
    get type() {
      return x.TYPE_COMMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        content: this.content
      });
    }
  }, Tt = class extends x {
    constructor(l, o, h) {
      super(), this.version = l, this.encoding = o ?? null, this.standalone = h ?? null;
    }
    get type() {
      return x.TYPE_XML_DECLARATION;
    }
    toJSON() {
      let l = x.prototype.toJSON.call(this);
      l.version = this.version;
      for (let o of ["encoding", "standalone"])
        this[o] !== null && (l[o] = this[o]);
      return l;
    }
  }, at = class Gn extends x {
    constructor(o, h = /* @__PURE__ */ Object.create(null), f = []) {
      super(), this.name = o, this.attributes = h, this.children = f;
    }
    /**
     * Whether this element is empty (meaning it has no children).
     */
    get isEmpty() {
      return this.children.length === 0;
    }
    get preserveWhitespace() {
      let o = this;
      for (; o instanceof Gn; ) {
        if ("xml:space" in o.attributes)
          return o.attributes["xml:space"] === "preserve";
        o = o.parent;
      }
      return !1;
    }
    /**
     * Text content of this element and all its descendants.
     */
    get text() {
      return this.children.map((o) => "text" in o ? o.text : "").join("");
    }
    get type() {
      return x.TYPE_ELEMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        name: this.name,
        attributes: this.attributes,
        children: this.children.map((o) => o.toJSON())
      });
    }
  }, St = class extends x {
    constructor(l = []) {
      super(), this.children = l;
    }
    get document() {
      return this;
    }
    /**
     * Root element of this document, or `null` if this document is empty.
     */
    get root() {
      for (let l of this.children)
        if (l instanceof at)
          return l;
      return null;
    }
    /**
     * Text content of this document and all its descendants.
     */
    get text() {
      return this.children.map((l) => "text" in l ? l.text : "").join("");
    }
    get type() {
      return x.TYPE_DOCUMENT;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        children: this.children.map((l) => l.toJSON())
      });
    }
  }, kt = class extends x {
    constructor(l, o, h, f) {
      super(), this.name = l, this.publicId = o ?? null, this.systemId = h ?? null, this.internalSubset = f ?? null;
    }
    get type() {
      return x.TYPE_DOCUMENT_TYPE;
    }
    toJSON() {
      let l = x.prototype.toJSON.call(this);
      l.name = this.name;
      for (let o of ["publicId", "systemId", "internalSubset"])
        this[o] !== null && (l[o] = this[o]);
      return l;
    }
  }, Ct = class extends Error {
    constructor(l, o, h) {
      let f = 1, g = "", v = 1;
      for (let ut = 0; ut < o; ++ut) {
        let Ot = h[ut];
        Ot === `
` ? (f = 1, g = "", v += 1) : (f += 1, g += Ot);
      }
      let O = h.indexOf(`
`, o);
      g += O === -1 ? h.slice(o) : h.slice(o, O);
      let $ = 0;
      g.length > 50 && (f < 40 ? g = g.slice(0, 50) : ($ = f - 20, g = g.slice($, f + 30))), super(
        `${l} (line ${v}, column ${f})
  ${g}
` + " ".repeat(f - $ + 1) + `^
`
      ), this.column = f, this.excerpt = g, this.line = v, this.name = "XmlError", this.pos = o;
    }
  }, ct = class extends x {
    constructor(l, o = "") {
      super(), this.name = l, this.content = o;
    }
    get type() {
      return x.TYPE_PROCESSING_INSTRUCTION;
    }
    toJSON() {
      return Object.assign(x.prototype.toJSON.call(this), {
        name: this.name,
        content: this.content
      });
    }
  }, Nt = "", Yt = class {
    /**
     * @param xml XML string to parse.
     * @param options Parser options.
     */
    constructor(l, o = {}) {
      let h = this.document = new St();
      this.j = h, this.g = o, this.c = new p(l), this.g.includeOffsets && (h.start = 0, h.end = l.length), this.parse();
    }
    /**
     * Adds the given `XmlNode` as a child of `this.currentNode`.
     */
    i(l, o) {
      return l.parent = this.j, this.g.includeOffsets && (l.start = this.c.f(o), l.end = this.c.f()), this.j.children.push(l), !0;
    }
    /**
     * Adds the given _text_ to the document, either by appending it to a
     * preceding `XmlText` node (if possible) or by creating a new `XmlText` node.
     */
    y(l, o) {
      let { children: h } = this.j, { length: f } = h;
      if (l = Q(l), f > 0) {
        let g = h[f - 1];
        if (g?.type === x.TYPE_TEXT) {
          let v = g;
          return v.text += l, this.g.includeOffsets && (v.end = this.c.f()), !0;
        }
      }
      return this.i(new J(l), o);
    }
    /**
     * Consumes element attributes.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-starttags
     */
    H() {
      let l = /* @__PURE__ */ Object.create(null);
      for (; this.e(); ) {
        let o = this.q();
        if (!o)
          break;
        let h = this.t() && this.I();
        if (h === !1)
          throw this.a("Attribute value expected");
        if (o in l)
          throw this.a(`Duplicate attribute: ${o}`);
        if (o === "xml:space" && h !== "default" && h !== "preserve")
          throw this.a('Value of the `xml:space` attribute must be "default" or "preserve"');
        l[o] = h;
      }
      if (this.g.sortAttributes) {
        let o = Object.keys(l).sort(), h = /* @__PURE__ */ Object.create(null);
        for (let f = 0; f < o.length; ++f) {
          let g = o[f];
          h[g] = l[g];
        }
        l = h;
      }
      return l;
    }
    /**
     * Consumes an `AttValue` (attribute value) if possible.
     *
     * @returns
     *   Contents of the `AttValue` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that an `AttValue` was consumed but
     *   was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-AttValue
     */
    I() {
      let { c: l } = this, o = l.m();
      if (o !== '"' && o !== "'")
        return !1;
      l.p();
      let h, f = !1, g = Nt, v = o === '"' ? m : w;
      t: for (; !l.B; )
        switch (h = l.x(v), h && (this.o(h), g += h.replace(y, " ")), l.m()) {
          case o:
            f = !0;
            break t;
          case "&":
            g += this.C();
            continue;
          case "<":
            throw this.a("Unescaped `<` is not allowed in an attribute value");
          default:
            break t;
        }
      if (!f)
        throw this.a("Unclosed attribute");
      return l.p(), g;
    }
    /**
     * Consumes a CDATA section if possible.
     *
     * @returns Whether a CDATA section was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-cdata-sect
     */
    J() {
      let { c: l } = this, o = l.d;
      if (!l.b("<![CDATA["))
        return !1;
      let h = l.s("]]>");
      if (this.o(h), !l.b("]]>"))
        throw this.a("Unclosed CDATA section");
      return this.g.preserveCdata ? this.i(new Z(Q(h)), o) : this.y(h, o);
    }
    /**
     * Consumes character data if possible.
     *
     * @returns Whether character data was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dt-chardata
     */
    K() {
      let { c: l } = this, o = l.d, h = l.x(b);
      if (!h)
        return !1;
      if (this.o(h), l.m(3) === "]]>")
        throw this.a("Element content may not contain the CDATA section close delimiter `]]>`");
      return this.y(h, o);
    }
    /**
     * Consumes a comment if possible.
     *
     * @returns Whether a comment was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Comment
     */
    D() {
      let { c: l } = this, o = l.d;
      if (!l.b("<!--"))
        return !1;
      let h = l.s("--");
      if (this.o(h), !l.b("-->"))
        throw l.m(2) === "--" ? this.a("The string `--` isn't allowed inside a comment") : this.a("Unclosed comment");
      return this.g.preserveComments ? this.i(new Et(Q(h)), o) : !0;
    }
    /**
     * Consumes a reference in a content context if possible.
     *
     * This differs from `consumeReference()` in that a consumed reference will be
     * added to the document as a text node instead of returned.
     *
     * @returns Whether a reference was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#entproc
     */
    L() {
      let l = this.c.d, o = this.C();
      return o ? this.y(o, l) : !1;
    }
    /**
     * Consumes a doctype declaration if possible.
     *
     * This is a loose implementation since doctype declarations are currently
     * discarded without further parsing.
     *
     * @returns Whether a doctype declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dtd
     */
    M() {
      let { c: l } = this, o = l.d;
      if (!l.b("<!DOCTYPE"))
        return !1;
      let h = this.e() && this.q();
      if (!h)
        throw this.a("Expected a name");
      let f, g;
      if (this.e()) {
        if (l.b("PUBLIC")) {
          if (f = this.e() && this.N(), f === !1)
            throw this.a("Expected a public identifier");
          this.e();
        }
        if (f !== void 0 || l.b("SYSTEM")) {
          if (this.e(), g = this.r(), g === !1)
            throw this.a("Expected a system identifier");
          this.e();
        }
      }
      let v;
      if (l.b("[")) {
        if (v = l.x(/\][\x20\t\r\n]*>/), !l.b("]"))
          throw this.a("Unclosed internal subset");
        this.e();
      }
      if (!l.b(">"))
        throw this.a("Unclosed doctype declaration");
      return this.g.preserveDocumentType ? this.i(new kt(h, f, g, v), o) : !0;
    }
    /**
     * Consumes an element if possible.
     *
     * @returns Whether an element was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-element
     */
    E() {
      let { c: l } = this, o = l.d;
      if (!l.b("<"))
        return !1;
      let h = this.q();
      if (!h)
        return l.n(o), !1;
      let f = this.H(), g = !!l.b("/>"), v = new at(h, f);
      if (v.parent = this.j, !g) {
        if (!l.b(">"))
          throw this.a(`Unclosed start tag for element \`${h}\``);
        this.j = v;
        do
          this.K();
        while (this.E() || this.L() || this.J() || this.F() || this.D());
        let O = l.d, $;
        if (!l.b("</") || !($ = this.q()) || $ !== h)
          throw l.n(O), this.a(`Missing end tag for element ${h}`);
        if (this.e(), !l.b(">"))
          throw this.a(`Unclosed end tag for element ${h}`);
        this.j = v.parent;
      }
      return this.i(v, o);
    }
    /**
     * Consumes an `Eq` production if possible.
     *
     * @returns Whether an `Eq` production was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Eq
     */
    t() {
      return this.e(), this.c.b("=") ? (this.e(), !0) : !1;
    }
    /**
     * Consumes `Misc` content if possible.
     *
     * @returns Whether anything was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Misc
     */
    z() {
      return this.D() || this.F() || this.e();
    }
    /**
     * Consumes one or more `Name` characters if possible.
     *
     * @returns `Name` characters, or an empty string if none were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Name
     */
    q() {
      return T(this.c.m()) ? this.c.w(S) : Nt;
    }
    /**
     * Consumes a processing instruction if possible.
     *
     * @returns Whether a processing instruction was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-pi
     */
    F() {
      let { c: l } = this, o = l.d;
      if (!l.b("<?"))
        return !1;
      let h = this.q();
      if (h) {
        if (h.toLowerCase() === "xml")
          throw l.n(o), this.a("XML declaration isn't allowed here");
      } else
        throw this.a("Invalid processing instruction");
      if (!this.e()) {
        if (l.b("?>"))
          return this.i(new ct(h), o);
        throw this.a("Whitespace is required after a processing instruction name");
      }
      let f = l.s("?>");
      if (this.o(f), !l.b("?>"))
        throw this.a("Unterminated processing instruction");
      return this.i(new ct(h, Q(f)), o);
    }
    /**
     * Consumes a prolog if possible.
     *
     * @returns Whether a prolog was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-prolog-dtd
     */
    O() {
      let { c: l } = this, o = l.d;
      for (this.P(); this.z(); )
        ;
      if (this.M())
        for (; this.z(); )
          ;
      return o < l.d;
    }
    /**
     * Consumes a public identifier literal if possible.
     *
     * @returns
     *   Value of the public identifier literal minus quotes, or `false` if
     *   nothing was consumed. An empty string indicates that a public id literal
     *   was consumed but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-PubidLiteral
     */
    N() {
      let l = this.c.d, o = this.r();
      if (o !== !1 && !/^[-\x20\r\na-zA-Z0-9'()+,./:=?;!*#@$_%]*$/.test(o))
        throw this.c.n(l), this.a("Invalid character in public identifier");
      return o;
    }
    /**
     * Consumes a reference if possible.
     *
     * This differs from `consumeContentReference()` in that a consumed reference
     * will be returned rather than added to the document.
     *
     * @returns
     *   Parsed reference value, or `false` if nothing was consumed (to
     *   distinguish from a reference that resolves to an empty string).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Reference
     */
    C() {
      let { c: l } = this;
      if (!l.b("&"))
        return !1;
      let o = l.w(P);
      if (l.G() !== ";")
        throw this.a("Unterminated reference (a reference must end with `;`)");
      let h;
      if (o[0] === "#") {
        let f = o[1] === "x" ? parseInt(o.slice(2), 16) : parseInt(o.slice(1), 10);
        if (isNaN(f))
          throw this.a("Invalid character reference");
        if (!z(f))
          throw this.a("Character reference resolves to an invalid character");
        h = String.fromCodePoint(f);
      } else if (h = E[o], h === void 0) {
        let {
          ignoreUndefinedEntities: f,
          resolveUndefinedEntity: g
        } = this.g, v = `&${o};`;
        if (g) {
          let O = g(v);
          if (O != null) {
            let $ = typeof O;
            if ($ !== "string")
              throw new TypeError(`\`resolveUndefinedEntity()\` must return a string, \`null\`, or \`undefined\`, but returned a value of type ${$}`);
            return O;
          }
        }
        if (f)
          return v;
        throw l.n(-v.length), this.a(`Named entity isn't defined: ${v}`);
      }
      return h;
    }
    /**
     * Consumes a `SystemLiteral` if possible.
     *
     * A `SystemLiteral` is similar to an attribute value, but allows the
     * characters `<` and `&` and doesn't replace references.
     *
     * @returns
     *   Value of the `SystemLiteral` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that a `SystemLiteral` was consumed
     *   but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-SystemLiteral
     */
    r() {
      let { c: l } = this, o = l.b('"') || l.b("'");
      if (!o)
        return !1;
      let h = l.s(o);
      if (this.o(h), !l.b(o))
        throw this.a("Missing end quote");
      return h;
    }
    /**
     * Consumes one or more whitespace characters if possible.
     *
     * @returns Whether any whitespace characters were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#white
     */
    e() {
      return !!this.c.w(R);
    }
    /**
     * Consumes an XML declaration if possible.
     *
     * @returns Whether an XML declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-XMLDecl
     */
    P() {
      let { c: l } = this, o = l.d;
      if (!l.b("<?xml"))
        return !1;
      if (!this.e())
        throw this.a("Invalid XML declaration");
      let h = !!l.b("version") && this.t() && this.r();
      if (h === !1)
        throw this.a("XML version is missing or invalid");
      if (!/^1\.[0-9]+$/.test(h))
        throw this.a("Invalid character in version number");
      let f, g;
      if (this.e()) {
        if (f = !!l.b("encoding") && this.t() && this.r(), f) {
          if (!/^[A-Za-z][\w.-]*$/.test(f))
            throw this.a("Invalid character in encoding name");
          this.e();
        }
        if (g = !!l.b("standalone") && this.t() && this.r(), g) {
          if (g !== "yes" && g !== "no")
            throw this.a('Only "yes" and "no" are permitted as values of `standalone`');
          this.e();
        }
      }
      if (!l.b("?>"))
        throw this.a("Invalid or unclosed XML declaration");
      return this.g.preserveXmlDeclaration ? this.i(new Tt(
        h,
        f || void 0,
        g || void 0
      ), o) : !0;
    }
    /**
     * Returns an `XmlError` for the current scanner position.
     */
    a(l) {
      let { c: o } = this;
      return new Ct(l, o.d, o.h);
    }
    /**
     * Parses the XML input.
     */
    parse() {
      if (this.c.b("\uFEFF"), this.O(), !this.E())
        throw this.a("Root element is missing or invalid");
      for (; this.z(); )
        ;
      if (!this.c.B)
        throw this.a("Extra content at the end of the document");
    }
    /**
     * Throws an invalid character error if any character in the given _string_
     * isn't a valid XML character.
     */
    o(l) {
      let { length: o } = l;
      for (let h = 0; h < o; ++h) {
        let f = l.codePointAt(h);
        if (!z(f))
          throw this.c.n(-([...l].length - h)), this.a("Invalid character");
        f > 65535 && (h += 1);
      }
    }
  };
  function Q(l) {
    let o = 0;
    for (; (o = l.indexOf("\r", o)) !== -1; )
      l = l[o + 1] === `
` ? l.slice(0, o) + l.slice(o + 1) : l.slice(0, o) + `
` + l.slice(o + 1);
    return l;
  }
  function Gt(l, o) {
    return new Yt(l, o).document;
  }
  return oe;
}
var no = eo();
function ro(e) {
  const t = String(e), n = [];
  return { toOffset: r, toPoint: i };
  function i(s) {
    if (typeof s == "number" && s > -1 && s <= t.length) {
      let a = 0;
      for (; ; ) {
        let c = n[a];
        if (c === void 0) {
          const u = qe(t, n[a - 1]);
          c = u === -1 ? t.length + 1 : u + 1, n[a] = c;
        }
        if (c > s)
          return {
            line: a + 1,
            column: s - (a > 0 ? n[a - 1] : 0) + 1,
            offset: s
          };
        a++;
      }
    }
  }
  function r(s) {
    if (s && typeof s.line == "number" && typeof s.column == "number" && !Number.isNaN(s.line) && !Number.isNaN(s.column)) {
      for (; n.length < s.line; ) {
        const c = n[n.length - 1], u = qe(t, c), d = u === -1 ? t.length + 1 : u + 1;
        if (c === d) break;
        n.push(d);
      }
      const a = (s.line > 1 ? n[s.line - 2] : 0) + s.column - 1;
      if (a < n[s.line - 1]) return a;
    }
  }
}
function qe(e, t) {
  const n = e.indexOf("\r", t), i = e.indexOf(`
`, t);
  return i === -1 ? n : n === -1 || n + 1 === i ? i : n < i ? n : i;
}
function io(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Ve(e.position) : "start" in e || "end" in e ? Ve(e) : "line" in e || "column" in e ? pe(e) : "";
}
function pe(e) {
  return We(e && e.line) + ":" + We(e && e.column);
}
function Ve(e) {
  return pe(e && e.start) + "-" + pe(e && e.end);
}
function We(e) {
  return e && typeof e == "number" ? e : 1;
}
class _ extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, i) {
    super(), typeof n == "string" && (i = n, n = void 0);
    let r = "", s = {}, a = !1;
    if (n && ("line" in n && "column" in n ? s = { place: n } : "start" in n && "end" in n ? s = { place: n } : "type" in n ? s = {
      ancestors: [n],
      place: n.position
    } : s = { ...n }), typeof t == "string" ? r = t : !s.cause && t && (a = !0, r = t.message, s.cause = t), !s.ruleId && !s.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? s.ruleId = i : (s.source = i.slice(0, u), s.ruleId = i.slice(u + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const u = s.ancestors[s.ancestors.length - 1];
      u && (s.place = u.position);
    }
    const c = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = c ? c.column : void 0, this.fatal = void 0, this.file = "", this.message = r, this.line = c ? c.line : void 0, this.name = io(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = a && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
_.prototype.file = "";
_.prototype.name = "";
_.prototype.reason = "";
_.prototype.message = "";
_.prototype.stack = "";
_.prototype.column = void 0;
_.prototype.line = void 0;
_.prototype.ancestors = void 0;
_.prototype.cause = void 0;
_.prototype.fatal = void 0;
_.prototype.place = void 0;
_.prototype.ruleId = void 0;
_.prototype.source = void 0;
function so(e) {
  const t = ro(e);
  let n;
  try {
    n = no.parseXml(String(e), {
      // Positional offsets.
      includeOffsets: !0,
      // `<![CDATA[>&<]]>`
      preserveCdata: !0,
      // `<!--a-->`
      preserveComments: !0,
      // `<!DOCTYPE b>` (a specific declaration)
      preserveDocumentType: !0,
      // `<?xml?>` (a specific instruction)
      preserveXmlDeclaration: !0
    });
  } catch (s) {
    const a = (
      /** @type {XmlError} */
      s
    ), c = t.toPoint(a.pos), u = new _(
      "Could not parse XML with `@rgrove/parse-xml`",
      {
        cause: a,
        place: c,
        ruleId: "error",
        source: "xast-util-from-xml"
      }
    );
    throw u.fatal = !0, u.url = "https://github.com/syntax-tree/xast-util-from-xml#throws", u;
  }
  const i = { location: t }, r = ao(n, i);
  return Qn(n, r, i), r;
}
function oo(e) {
  return { type: "cdata", value: e.text };
}
function lo(e) {
  return { type: "comment", value: e.content };
}
function ao(e, t) {
  return { type: "root", children: Zn(e.children, t) };
}
function co(e) {
  return {
    type: "doctype",
    name: e.name,
    public: e.publicId || void 0,
    system: e.systemId || void 0
  };
}
function uo(e, t) {
  const n = Zn(e.children, t);
  return {
    type: "element",
    name: e.name,
    attributes: { ...e.attributes },
    // @ts-expect-error: assume content matches.
    children: n
  };
}
function ho(e) {
  return { type: "instruction", name: e.name, value: e.content };
}
function fo(e) {
  return { type: "text", value: e.text };
}
function po(e) {
  const t = [];
  return e.version && t.push('version="' + e.version + '"'), e.encoding && t.push('encoding="' + e.encoding + '"'), e.standalone && t.push('standalone="' + e.standalone + '"'), { type: "instruction", name: "xml", value: t.join(" ") };
}
function Zn(e, t) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const r = e[i];
    let s;
    r.type === "cdata" ? s = oo(
      /** @type {XmlCdata} */
      r
    ) : r.type === "comment" ? s = lo(
      /** @type {XmlComment} */
      r
    ) : r.type === "doctype" ? s = co(
      /** @type {XmlDocumentType} */
      r
    ) : r.type === "element" ? s = uo(
      /** @type {XmlElement} */
      r,
      t
    ) : r.type === "pi" ? s = ho(
      /** @type {XmlProcessingInstruction} */
      r
    ) : r.type === "text" ? s = fo(
      /** @type {XmlText} */
      r
    ) : r.type === "xmldecl" && (s = po(
      /** @type {XmlDeclaration} */
      r
    )), s && (Qn(r, s, t), n.push(s));
  }
  return n;
}
function Qn(e, t, n) {
  const i = (
    // Doesn’t practically happen as far as I found, but `-1` is used in the
    // code, so let’s keep it in.
    /* c8 ignore next */
    e.start === -1 ? void 0 : n.location.toPoint(e.start)
  ), r = (
    // Same as above
    /* c8 ignore next */
    e.end === -1 ? void 0 : n.location.toPoint(e.end)
  );
  i && r && (t.position = { start: i, end: r });
}
const tr = [
  "abstract",
  "acknowledgement",
  "affiliation",
  "appendix",
  "article",
  "author",
  "backmatter",
  "biography",
  "book",
  "chapter",
  "colophon",
  "contributor",
  "contributors",
  "copyright",
  "credit",
  "dedication",
  "docinfo",
  "editor",
  "feedback",
  "frontmatter",
  "google",
  "html",
  "index",
  "macros",
  "mathbook",
  "preface",
  "pretext",
  "references",
  "search",
  "shortlicense",
  "solutions",
  "subsection",
  "titlepage",
  "website"
], er = [
  "assemblage",
  "chapter",
  "conclusion",
  "introduction",
  "objectives",
  "outcomes",
  "paragraphs",
  "part",
  "postlude",
  "prelude",
  "reading-questions",
  "sbsgroup",
  "section",
  "stack",
  "subsection",
  "subsubsection",
  "task",
  "technology",
  "worksheet"
], nr = [
  "activity",
  "algorithm",
  "answer",
  "axiom",
  "biblio",
  "blockquote",
  "case",
  "choice",
  "choices",
  "claim",
  "conjecture",
  "console",
  "corollary",
  "definition",
  "demonstration",
  "description",
  "example",
  "exercise",
  "exploration",
  "fact",
  "hint",
  "image",
  "images",
  "insight",
  "interactive",
  "investigation",
  "lemma",
  "list",
  "listing",
  "note",
  "openconjecture",
  "openproblem",
  "openquestion",
  "page",
  "poem",
  "principle",
  "problem",
  "program",
  "project",
  "proof",
  "proposition",
  "question",
  "remark",
  "shortdescription",
  "solution",
  "stanza",
  "statement",
  "subtask",
  "table",
  "tabular",
  "theorem",
  "video",
  "warning",
  "webwork"
], rr = [
  "address",
  "attribution",
  "caption",
  "cline",
  "date",
  "department",
  "description",
  "edition",
  "entity",
  "holder",
  "idx",
  "institution",
  "journal",
  "line",
  "location",
  "minilicense",
  "mrow",
  "personname",
  "pg-macros",
  "pubtitle",
  "subtitle",
  "support",
  "title",
  "usage",
  "volume",
  "year",
  "xi:include"
], mo = ["ol", "ul", "dl"], go = ["me", "men", "md", "mdn"], ir = [
  "ul",
  "ol",
  "li",
  "p",
  "task",
  "figure",
  "sidebyside",
  "notation",
  "row"
], sr = [
  "latex-image-preamble",
  "latex-image",
  "latex-preamble",
  "slate",
  "sage",
  "sageplot",
  "asymptote",
  "macros",
  "prefigure",
  "program",
  "preamble",
  "postamble",
  "input",
  "output",
  "prompt",
  "pre",
  "pg-code",
  "script",
  "tikzpicture",
  "tikz",
  "code",
  "c",
  "cd"
], yo = [
  ...tr,
  ...er,
  ...nr,
  ...ir,
  "xi:include"
], wo = [
  ...tr,
  ...er,
  ...nr,
  ...ir,
  ...go,
  ...mo
], Ye = ["p", "li", "fn"], bo = [
  "title",
  "shorttitle",
  "subtitle",
  "caption",
  "attribution",
  "personname",
  "location",
  "date",
  "edition",
  "entity",
  "support",
  "name",
  "given",
  "family",
  "usage",
  "volume",
  "number",
  "collection-title",
  "page",
  "year",
  "publisher",
  "publisher-place",
  "URL",
  "issued",
  "description",
  "shortdescription",
  "q",
  "premise",
  "response",
  "li",
  "cell"
];
function vo(e) {
  return { ind: " ".repeat(2), blankLines: "some", breakSentences: !1, breakLongAttributes: !1, printWidth: 80 };
}
function xo(e, t) {
  const n = vo(), i = [];
  e.children.length === 1 && e.children[0].type === "element" && e.children[0].name === "tmp-root" && (e = { ...e, children: e.children[0].children });
  for (const s of e.children)
    me(s, i, 0, n);
  const r = No(i, n);
  for (; r.length > 0 && r[r.length - 1] === ""; ) r.pop();
  return r.join(`
`);
}
function Eo(e, t) {
  let n, i = null;
  if (e.startsWith("<?xml")) {
    const s = e.indexOf("?>");
    if (s !== -1) {
      const a = s + 2;
      i = e.slice(0, a), e = e.slice(a);
    }
  }
  e = `<tmp-root>${e}</tmp-root>`;
  try {
    n = so(e);
  } catch {
    return console.warn("Input is not well-formed XML; returning original text."), e = e.replace(/<tmp-root>(.*?)<\/tmp-root>/s, "$1"), i && (e = i + `

` + e), e;
  }
  let r = xo(n);
  return i && (r = i + `

` + r), r;
}
function me(e, t, n, i) {
  switch (e.type) {
    case "instruction":
      t.push(`<?${e.name}${e.value ? " " + e.value : ""}?>`);
      break;
    case "doctype":
      t.push(`<!DOCTYPE ${e.name}>`);
      break;
    case "comment":
      t.push(`${i.ind.repeat(n)}<!--${e.value}-->`);
      break;
    case "cdata":
      t.push(
        `${i.ind.repeat(n)}<![CDATA[${e.value}]]>`
      );
      break;
    case "text": {
      const r = e.value.trim();
      r && t.push(`${i.ind.repeat(n)}${Wt(r)}`);
      break;
    }
    case "element":
      or(e, t, n, i);
      break;
  }
}
function or(e, t, n, i) {
  const r = e.name;
  sr.includes(r) ? To(e, t, n, i) : bo.includes(r) ? ko(e, t, n, i) : rr.includes(r) ? So(e, t, n, i) : Ye.includes(r) && !dr(e) ? Co(e, t, n, i) : Ye.includes(r) ? lr(e, t, n, i) : ar(e, t, n, i);
}
function To(e, t, n, i) {
  if (e.children.some((a) => a.type === "element")) {
    ar(e, t, n, i);
    return;
  }
  const r = i.ind.repeat(n);
  if (lt(e)) {
    t.push(`${r}${gt(e)}`);
    return;
  }
  const s = e.children.map((a) => a.type === "text" ? Wt(a.value) : a.type === "cdata" ? `<![CDATA[${a.value}]]>` : "").join("");
  if (/\n[ \t]*$/.test(s)) {
    const a = s.replace(/\n[ \t]*$/, `
`);
    t.push(`${r}${it(e)}${a}${r}</${e.name}>`);
  } else
    t.push(`${r}${it(e)}${s}</${e.name}>`);
}
function So(e, t, n, i) {
  const r = i.ind.repeat(n);
  if (lt(e)) {
    t.push(`${r}${gt(e)}`);
    return;
  }
  const s = Te(e.children);
  t.push(`${r}${it(e)}${s}</${e.name}>`);
}
function ko(e, t, n, i) {
  const r = i.ind.repeat(n);
  if (lt(e)) {
    t.push(`${r}${gt(e)}`);
    return;
  }
  if (dr(e)) {
    lr(e, t, n, i);
    return;
  }
  const s = Se(e.children), a = i.ind.repeat(n + 1), c = `${r}${it(e)}${s.join(" ")}</${e.name}>`;
  if (i.printWidth === 0 || c.length <= i.printWidth) {
    t.push(c);
    return;
  }
  t.push(`${r}${it(e)}`);
  for (const u of ke(s, i.printWidth, a.length, i.breakSentences))
    t.push(`${a}${u}`);
  t.push(`${r}</${e.name}>`);
}
function Co(e, t, n, i) {
  const r = i.ind.repeat(n), s = i.ind.repeat(n + 1);
  if (lt(e)) {
    t.push(`${r}${gt(e)}`);
    return;
  }
  t.push(`${r}${it(e)}`);
  const a = Se(e.children);
  for (const c of ke(a, i.printWidth, s.length, i.breakSentences))
    t.push(`${s}${c}`);
  t.push(`${r}</${e.name}>`);
}
function lr(e, t, n, i) {
  const r = i.ind.repeat(n), s = i.ind.repeat(n + 1);
  if (lt(e)) {
    t.push(`${r}${gt(e)}`);
    return;
  }
  t.push(`${r}${it(e)}`);
  const a = ge(e);
  let c = 0;
  for (; c < a.length; )
    if (ye(a[c])) {
      const u = a[c];
      c++;
      let d = "";
      if (c < a.length && a[c].type === "text") {
        const m = a[c].value, w = /^(\s*)([.,;:!?])/.exec(m);
        if (w) {
          d = w[2];
          const y = m.slice(w[0].length);
          a[c].value = y, y.trim() || c++;
        }
      }
      const p = [];
      or(u, p, n + 1, i), d && p.length > 0 && (p[p.length - 1] += d), t.push(...p);
    } else {
      const u = [];
      for (; c < a.length && !ye(a[c]); )
        u.push(a[c]), c++;
      const d = Se(u);
      if (d.length > 0)
        for (const p of ke(d, i.printWidth, s.length, i.breakSentences))
          t.push(`${s}${p}`);
    }
  t.push(`${r}</${e.name}>`);
}
function ar(e, t, n, i) {
  const r = i.ind.repeat(n);
  if (lt(e)) {
    t.push(...le(e, n, i, !0));
    return;
  }
  const s = ge(e);
  if (s.length === 1 && s[0].type === "element" && s[0].name === "xi:include") {
    const a = s[0], c = le(e, n, i);
    if (c.length === 1) {
      const u = lt(a) ? gt(a) : `${it(a)}${Te(a.children)}</${a.name}>`;
      t.push(`${c[0]}${u}</${e.name}>`);
      return;
    }
    t.push(...c), me(a, t, n + 1, i), t.push(`${r}</${e.name}>`);
    return;
  }
  t.push(...le(e, n, i));
  for (const a of ge(e))
    me(a, t, n + 1, i);
  t.push(`${r}</${e.name}>`);
}
function No(e, t) {
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const r = e[i].trim(), s = i < e.length - 1 ? e[i + 1].trim() : null;
    if (n.push(e[i]), i === 0 && /^<\?xml(?:\s|\?>)/.test(r)) {
      n.push("");
      continue;
    }
    if (t.blankLines !== "few")
      if (t.blankLines === "some")
        if (r.startsWith("</") && s !== null && s.startsWith("<")) {
          const a = /^<([^\s>/]+)/.exec(s)?.[1];
          a && yo.includes(a) && n.push("");
        } else /^<title[\s>]/.test(r) && r.includes("</title>") && n.push("");
      else t.blankLines === "many" && (r.startsWith("</") || r.startsWith("<") && s !== null && s.startsWith("<")) && n.push("");
  }
  return n;
}
function Te(e) {
  return e.map((t) => t.type === "text" ? Wt(t.value) : t.type === "element" ? cr(t) : t.type === "comment" ? `<!--${t.value}-->` : t.type === "cdata" ? `<![CDATA[${t.value}]]>` : "").join("");
}
function cr(e) {
  return lt(e) ? gt(e) : `${it(e)}${Te(e.children)}</${e.name}>`;
}
function Se(e) {
  const t = [];
  for (const n of e)
    if (n.type === "text") {
      const i = n.value.split(/\s+/).filter((r) => r.length > 0);
      for (let r = 0; r < i.length; r++) {
        const s = Wt(i[r]);
        r === 0 && t.length > 0 && /^[.,;:!?\-]/.test(s) ? t[t.length - 1] += s : t.push(s);
      }
    } else n.type === "element" ? t.push(cr(n)) : n.type === "comment" && t.push(`<!--${n.value}-->`);
  return t;
}
function ke(e, t, n, i) {
  if (e.length === 0) return [];
  const r = t === 0 ? 1 / 0 : Math.max(20, t - n), s = [];
  let a = "";
  for (let c = 0; c < e.length; c++) {
    const u = e[c];
    a === "" ? a = u : a.length + 1 + u.length <= r ? a += " " + u : (s.push(a), a = u), i && /[.!?]$/.test(u) && c < e.length - 1 && (s.push(a), a = "");
  }
  return a && s.push(a), s;
}
function it(e) {
  const t = ur(e);
  return t ? `<${e.name} ${t}>` : `<${e.name}>`;
}
function gt(e) {
  const t = ur(e);
  return t ? `<${e.name} ${t}/>` : `<${e.name}/>`;
}
function ur(e) {
  return hr(e).join(" ");
}
function hr(e) {
  return Object.entries(e.attributes || {}).map(([t, n]) => n == null ? t : `${t}="${Oo(n)}"`);
}
function le(e, t, n, i = !1) {
  const r = n.ind.repeat(t), s = hr(e), a = i ? "/>" : ">";
  if (s.length === 0)
    return [`${r}<${e.name}${a}`];
  const c = `${r}<${e.name} ${s.join(" ")}${a}`;
  if (!n.breakLongAttributes || n.printWidth === 0 || c.length <= n.printWidth)
    return [c];
  const u = `${r}${" ".repeat(e.name.length + 2)}`, d = [`${r}<${e.name} ${s[0]}`];
  for (const p of s.slice(1))
    d.push(`${u}${p}`);
  return d[d.length - 1] += a, d;
}
function lt(e) {
  return e.children.every(
    (t) => t.type === "text" && t.value.trim() === ""
  );
}
function ge(e) {
  return e.children.filter(
    (t) => !(t.type === "text" && t.value.trim() === "")
  );
}
function ye(e) {
  if (e.type !== "element") return !1;
  const t = e.name;
  return t === "c" ? !1 : (wo.includes(t) || sr.includes(t)) && !rr.includes(t);
}
function dr(e) {
  return e.children.some((t) => ye(t));
}
function Wt(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Oo(e) {
  return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
const Io = A.create({
  name: "ptxFragment",
  topNode: !0,
  //content: "title? introduction? part* chapter* section* subsection* worksheet*",
  content: "ptxdoc"
}), Mo = [
  Nr.configure({
    defaultLanguage: "xml"
  }),
  //KeyboardCommands,
  Io,
  Kr,
  is,
  Sr,
  kr,
  Cr,
  zr,
  ss,
  os,
  ls,
  as,
  Or,
  Ir,
  Mr,
  mr.configure({ mode: "deepest" }),
  fr,
  pr
  //onPaste: (currentEditor, files, htmlContent) => {
  //  files.forEach((file) => {
  //    if (htmlContent) {
  //      console.log(htmlContent);
  //      return false;
  //    }
  //    const fileReader = new FileReader();
  //    fileReader.readAsDataURL(file);
  //    fileReader.onload = () => {
  //      currentEditor
  //        .chain()
  //        .insertContentAt(currentEditor.state.selection.anchor, {
  //          type: "image",
  //          attrs: { src: fileReader.result },
  //        })
  //        .focus()
  //        .run();
  //    };
  //  });
  //},
], Jo = ({
  content: e,
  onChange: t,
  canEdit: n = !0,
  editDisabledReason: i
}) => {
  const r = K(null), s = K(!1), [a, c] = we(!1), u = n && a, d = wr({
    extensions: Mo,
    content: e,
    onContentError(m) {
      console.log("Content error: ", m.error), m.disableCollaboration(), m.editor.setEditable(!1, !1);
    },
    enableContentCheck: !0,
    onUpdate: ({ editor: m }) => {
      console.log("Editor update detected."), r.current && clearTimeout(r.current), r.current = setTimeout(() => {
        s.current && t(Eo(cs(m.getJSON())));
      }, 500);
    }
  });
  j(() => () => {
    r.current && clearTimeout(r.current);
  }, []);
  const p = K(!0);
  return j(() => {
    if (d && e !== d.getHTML() && p.current) {
      const m = e;
      if (d)
        try {
          d.commands.setContent(ji(m), {
            emitUpdate: !1
          }), console.log("External content set in visual editor.");
        } catch (w) {
          console.error("Error setting content: ", w);
        }
    }
  }, [e, d]), j(() => {
    if (!d) return;
    const m = () => {
      p.current = !1;
    };
    return d.on("update", m), () => {
      d.off("update", m);
    };
  }, [d]), j(() => {
    p.current = !0;
  }, [e]), j(() => {
    s.current = u, d && d.setEditable(u, !1);
  }, [d, u]), /* @__PURE__ */ F("div", { className: "pretext-plus-editor__visual-editor", children: [
    /* @__PURE__ */ F("div", { className: "pretext-plus-editor__visual-editor-header", children: [
      /* @__PURE__ */ N("p", { className: "pretext-plus-editor__visual-editor-title", children: "Simple Preview" }),
      n ? /* @__PURE__ */ F("label", { className: "pretext-plus-editor__edit-toggle", children: [
        /* @__PURE__ */ N(
          "input",
          {
            className: "pretext-plus-editor__edit-checkbox",
            type: "checkbox",
            checked: a,
            onChange: () => c(!a)
          }
        ),
        "Edit"
      ] }) : /* @__PURE__ */ N("p", { className: "pretext-plus-editor__visual-editor-hint", children: i || "Read-only preview" })
    ] }),
    /* @__PURE__ */ N("div", { className: (u ? "editable" : "read-only") + " ptx-page", children: /* @__PURE__ */ N(br, { editor: d }) }),
    n ? /* @__PURE__ */ N(to, { editor: d }) : null
  ] });
}, Fo = A.create({
  name: "em",
  content: "text*",
  inline: !0,
  group: "inline",
  parseHTML() {
    return [{ tag: "em" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "em" }, e), 0];
  }
}), Lo = (e) => ({
  pos: () => e.state.selection.$anchor.pos,
  depth: () => e.state.selection.$anchor.depth,
  inTextNode: () => e.state.selection.$anchor.parent.firstChild ? e.state.selection.$anchor.parent.firstChild.isText : !1,
  prevNodeIsText: () => e.state.selection.$anchor.nodeBefore ? e.state.selection.$anchor.nodeBefore.isText : !1,
  nextNodeIsText: () => e.state.selection.$anchor.nodeAfter ? e.state.selection.$anchor.nodeAfter.type.name === "text" : !1,
  parentType: () => e.state.selection.$anchor.parent.type.name,
  anchor: () => e.state.selection.$anchor,
  nextNodeSize: () => e.state.selection.$anchor.nodeAfter ? e.state.selection.$anchor.nodeAfter.nodeSize : 0,
  prevNodeSize: () => e.state.selection.$anchor.nodeBefore ? e.state.selection.$anchor.nodeBefore.nodeSize : 0
}), Xo = G.create({
  name: "keyboardCommands",
  addKeyboardShortcuts() {
    const e = Lo(this.editor);
    return {
      "Mod-i": () => (console.log(e.anchor()), !0),
      // ArrowLeft moves focus to parent node, unless the cursor is in the middle of a text node, in which case it should just do the "normal" thing.
      ArrowLeft: () => e.prevNodeIsText() ? !1 : e.depth() > 0 ? (console.log(e.depth()), this.editor.commands.selectParentNode(), this.editor.commands.scrollIntoView(), !0) : (this.editor.commands.focus("start", { scrollIntoView: !0 }), !0),
      // ArrowRight moves the position of the cursor to the next position, which can be the next text position or the next node.
      ArrowRight: () => (this.editor.commands.focus(e.pos() + 1, { scrollIntoView: !0 }), !0),
      // ArrowDown should move the cursor to the next node at the same depth if on a box.  If in a text node, do the default.
      ArrowDown: () => e.inTextNode() || e.prevNodeSize() === 0 && e.nextNodeSize() === 0 ? !1 : (this.editor.commands.focus(e.pos() + e.nextNodeSize(), {
        scrollIntoView: !0
      }), !0),
      // ArrowUp should move the cursor to the start of the previous node at the same depth if on a box.  If in a text node, do the default.
      ArrowUp: () => e.inTextNode() || e.prevNodeSize() === 0 && e.nextNodeSize() === 0 ? !1 : (this.editor.commands.focus(e.pos() - e.prevNodeSize(), {
        scrollIntoView: !0
      }), !0),
      // Enter should move the cursor onto the child node if on a box, or add a line break if in a text node.  The second time Enter is pressed inside a text node, directly after a hardBreak, the cursor should create a new text node.
      Enter: () => {
        if (e.inTextNode()) {
          if (!e.prevNodeIsText() && e.prevNodeSize() === 1) {
            const t = e.pos();
            return this.editor.commands.splitBlock(), this.editor.commands.deleteRange({ from: t - 1, to: t + 1 }), !0;
          }
          return this.editor.commands.setHardBreak(), !0;
        } else
          return !0;
      },
      "Mod-q": () => this.editor.commands.blur(),
      // Escape moves focus to parent node.
      Escape: () => this.editor.commands.selectParentNode(),
      "Mod-Right": () => this.editor.commands.selectNodeForward(),
      "Mod-Down": () => this.editor.commands.selectNodeForward()
      // 'Alt-ArrowUp': () => this.editor.commands.setNodeSelection(currentPos.before ? currentPos.before.pos : currentPos.pos),
      // 'Alt-ArrowDown': () => this.editor.commands.setNodeSelection(currentPos.after ? currentPos.after.pos : currentPos.pos),
    };
  }
}), Ko = At.create({
  name: "unknownMark",
  group: "marks",
  parseHTML() {
    return [{ tag: "unknown" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", L({ class: "unknown" }, e), 0];
  }
}), jo = ({ editor: e }) => {
  const [t] = Mt.useState(!0);
  return j(() => {
    e && e.setEditable(t);
  }, [t, e]), e ? /* @__PURE__ */ N(Ge, { children: e && /* @__PURE__ */ N(
    Qs,
    {
      editor: e,
      shouldShow: null,
      className: "floating-menu",
      children: /* @__PURE__ */ F("div", { className: "floating-menu", "data-testid": "floating-menu", children: [
        /* @__PURE__ */ N(
          "button",
          {
            onClick: () => e.chain().focus().setNode("theorem").run(),
            className: e.isActive("p") ? "is-active" : "",
            children: "Theorem"
          }
        ),
        /* @__PURE__ */ N(
          "button",
          {
            onClick: () => e.chain().focus().setNode("proof").run(),
            className: e.isActive("p") ? "is-active" : "",
            children: "Proof"
          }
        )
      ] })
    }
  ) }) : null;
}, qo = (e) => {
  let t;
  return e.showPreviewModeToggle === !1 ? t = null : t = /* @__PURE__ */ F("label", { className: "pretext-plus-editor__preview-toggle", children: [
    /* @__PURE__ */ N(
      "input",
      {
        type: "checkbox",
        checked: !e.isChecked,
        onChange: e.onChange,
        className: "pretext-plus-editor__preview-toggle-input"
      }
    ),
    /* @__PURE__ */ F("div", { className: "pretext-plus-editor__preview-toggle-container", children: [
      /* @__PURE__ */ N("span", { className: "pretext-plus-editor__preview-toggle-label", children: "Simple" }),
      /* @__PURE__ */ N(
        "span",
        {
          className: `pretext-plus-editor__preview-toggle-slider ${e.isChecked ? "pretext-plus-editor__preview-toggle-slider--active" : ""}`,
          children: /* @__PURE__ */ N(
            "span",
            {
              className: `pretext-plus-editor__preview-toggle-dot ${e.isChecked ? "pretext-plus-editor__preview-toggle-dot--active" : ""}`
            }
          )
        }
      ),
      /* @__PURE__ */ N("span", { className: "pretext-plus-editor__preview-toggle-label", children: "Full" })
    ] }),
    /* @__PURE__ */ N("span", { className: "pretext-plus-editor__preview-toggle-caption", children: "Preview Mode" }),
    /* @__PURE__ */ N(
      "input",
      {
        type: "checkbox",
        checked: e.isChecked,
        onChange: e.onChange,
        className: "pretext-plus-editor__preview-toggle-input"
      }
    )
  ] }), /* @__PURE__ */ F("div", { className: "pretext-plus-editor__menu-bar", children: [
    /* @__PURE__ */ N("div", { className: "pretext-plus-editor__menu-left", children: e.title !== void 0 && e.onTitleChange && /* @__PURE__ */ F("label", { className: "pretext-plus-editor__title-label", children: [
      "Title",
      " ",
      /* @__PURE__ */ N(
        "input",
        {
          className: "pretext-plus-editor__title-input",
          type: "text",
          value: e.title,
          onChange: (n) => e.onTitleChange?.(n.target.value)
        }
      )
    ] }) }),
    /* @__PURE__ */ F("div", { className: "pretext-plus-editor__menu-right", children: [
      e.onSaveButton && /* @__PURE__ */ N(
        "button",
        {
          className: "pretext-plus-editor__button pretext-plus-editor__button--save",
          onClick: e.onSaveButton,
          children: e.saveButtonLabel || "Save"
        }
      ),
      e.onCancelButton && /* @__PURE__ */ N(
        "button",
        {
          className: "pretext-plus-editor__button pretext-plus-editor__button--cancel",
          onClick: e.onCancelButton,
          children: e.cancelButtonLabel || "Cancel"
        }
      ),
      e.feedbackControl,
      t
    ] })
  ] });
};
export {
  Gi as AxiomLike,
  is as Blocks,
  os as Definition,
  zr as Divisions,
  Fo as Emph,
  ts as ExampleLike,
  Kr as Inline,
  Ki as KNOWN_TAGS,
  Xo as KeyboardCommands,
  Mr as MathDisplay,
  Ir as MathEquation,
  Or as MathInline,
  qo as MenuBar,
  fn as ProofComponent,
  to as PtxBubbleMenu,
  jo as PtxFloatingMenu,
  as as RawPtx,
  Zi as Statement,
  Rt as TheoremLikeComponent,
  Wi as TheoremLikeExtension,
  ss as Title,
  Ko as UnknownMark,
  ls as Url,
  Jo as VisualEditor,
  ji as cleanPtx,
  Lo as getCursorPos,
  cs as json2ptx
};
//# sourceMappingURL=index.js.map
